/* Innovation Flooring Direct — carpet quote builder, front end.
   Reads the data island written by sections/ifd-carpet-quote.liquid, drives the
   nine steps, draws the room and roll layouts, checks live stock before the
   deposit is offered and again when it is clicked, and adds the roll line then
   the deposit line to the cart.

   Nothing here writes _reserve_variant_id or _reserve_packs. Carpet is reserved
   by the real roll line in the cart, which Shopify deducts at order creation.

   Round 2: the Storefront API is the only thing that decides whether a roll is
   long enough. The Liquid data island is for display alone, because theme
   inventory figures on this store lag admin changes by up to several minutes.
   Every live check fails closed: no answer means no deposit.

   Round 5 (15 Sept 2026): the job "I know the length I need". The customer
   picks the carpet first, then types a length; the width and the length limit
   come from the roll. Nothing is sold by the full roll. The reservation, the
   live check and every cart property keep exactly the same shape. */
(function () {
  'use strict';

  var root = document.getElementById('cq-root');
  if (!root) return;
  var island = document.getElementById('cq-data');
  if (!island) return;
  var E = window.CQEngine;
  if (!E) return;

  var DATA = {};
  try { DATA = JSON.parse(island.textContent); } catch (e) { DATA = {}; }
  var TOKEN = root.getAttribute('data-cq-token') || '';
  var SHOP_DOMAIN = root.getAttribute('data-cq-domain') || '';
  var LIVE_API = 'https://' + SHOP_DOMAIN + '/api/2025-07/graphql.json';
  var MSG_NO_TOKEN = 'Live stock check is not set up yet.';
  var MSG_UNKNOWN = 'We could not confirm this roll\'s live stock. Please refresh the page or call us on the shop number and we will reserve it for you.';
  var MSG_NO_SINGLE_ROLL = 'This job needs more carpet than any single roll of this colour has left. Two rolls can shade differently, so we need to check this with you before it is reserved. Call us or send us the quote reference.';
  var RATES = Object.assign({}, E.RATES, DATA.rates || {});
  var CFG = DATA.cfg || {};
  var PRODUCTS = normaliseProducts(DATA.products || []);
  var KEY = 'ifdCQ';

  /* ------------------------------------------------------------- helpers */
  function money(p) {
    return '£' + (Math.round(p) / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(x) {
    return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fm(x) { return E.fmtM(x || 0); }
  function num(x) { var n = parseFloat(x); return isFinite(n) ? n : 0; }
  function $(id) { return document.getElementById(id); }
  function money0(p) { return '£' + (Math.round(p) / 100).toLocaleString('en-GB', { maximumFractionDigits: 0 }); }

  function normaliseProducts(list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      var ppm = p.ppm;
      if (ppm && typeof ppm === 'object') ppm = ppm.amount;
      ppm = Math.round((parseFloat(ppm) || 0) * 100);
      var rolls = [];
      for (var j = 0; j < (p.rolls || []).length; j++) {
        var v = p.rolls[j];
        var units = parseInt(v.u, 10) || 0;
        if (units <= 0) continue;                       /* sold-out rolls are hidden */
        rolls.push({
          id: String(v.id), sku: v.sku || '', rollNumber: v.rn || v.sku || '',
          widthM: parseFloat(v.w) || 4, originalLengthM: parseFloat(v.ol) || 0,
          units: units, lengthM: Math.round(units) / 10,
          site: v.site || '', status: v.st || '',
          sellOnline: v.sell !== false, showroomVisible: v.vis !== false,
          where: E.siteWording(v.site || ''),
          lengthStatus: E.rollStatus(units)
        });
      }
      var stockType = p.stock || '';
      var orderWidths = [];
      for (var wi = 0; wi < (p.widths || []).length; wi++) {
        var wv = parseFloat(p.widths[wi]);
        if (isFinite(wv) && wv > 0) orderWidths.push(wv);
      }
      orderWidths.sort(function (a, b) { return a - b; });
      var isOrderIn = stockType !== 'Shop-stock roll' && orderWidths.length > 0;
      /* A carpet that is neither a shop-stock roll nor an order-in range with
         its widths on file is not offered in the builder at all. */
      if (!isOrderIn && !rolls.length) continue;
      if (isOrderIn) rolls = [];
      rolls.sort(function (a, b) { return String(a.rollNumber).localeCompare(String(b.rollNumber)); });
      out.push({
        handle: p.h, title: p.t, url: p.url, img: p.img,
        stockType: stockType, orderIn: isOrderIn, orderWidths: orderWidths,
        pricePerM2Pence: ppm,
        classification: p.cls || 'Directional pile',
        patternRepeatM: parseFloat(p.rep) || 0,
        stairsSuitable: p.stairs === true,
        heavyDomestic: p.heavy === true,
        recommendedUnderlay: p.und || '',
        pileStyle: p.pile || '', feel: p.feel || [], material: p.mat || '',
        backing: p.back || '', inStore: p.instore === true, rooms: p.suit || [],
        rolls: rolls,
        widths: isOrderIn ? orderWidths : rolls.map(function (r) { return r.widthM; }).filter(function (v, k, a) { return a.indexOf(v) === k; }).sort(),
        allRemnant: !isOrderIn && rolls.length > 0 && rolls.every(function (r) { return r.lengthStatus.key === 'remnant'; })
      });
    }
    return out;
  }

  /* --------------------------------------------------------------- state */
  function blank() {
    return {
      job: '', unit: 'm',
      rooms: [], stairs: null,
      cutLen: '', cutWidth: 0,
      prod: '', roll: '', rollAuto: false, orderWidth: 0,
      underlay: '', gripper: '', doorBars: 0, doorBarOther: '',
      uplift: null, disposal: null, furnitureRooms: 0,
      fitting: '', route: '',
      name: '', email: '', tel: '', addr: '', postcode: '', notes: '',
      ref: '', idx: 0
    };
  }
  var S = blank();
  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && typeof saved === 'object') S = Object.assign(blank(), saved);
  } catch (e) {}
  function save() { try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {} }
  function mkref() {
    if (!S.ref) {
      var d = new Date();
      S.ref = 'CQ-' + d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2)
        + '-' + (1000 + Math.floor(Math.random() * 9000));
    }
    return S.ref;
  }

  function newRoom(name) { return { name: name || '', l: '', w: '', doors: 1, extras: [] }; }
  function newStairs(type) {
    return {
      type: type || 'straight', coverage: 'full', stairWidth: '', runnerWidth: 0.69,
      flights: [{ label: 'Staircase', count: '', tread: '', riser: '' }],
      landings: [], winders: [], photoNote: ''
    };
  }

  var JOBS = [
    /* Round 5: the clearance customer's route. Carpet first, then the length. */
    { k: 'cut', n: 'I know the length I need', d: 'Tell us the length and we cut it straight off the roll.', rooms: 0, stairs: false, cut: true },
    { k: 'one', n: 'One room', d: 'A lounge, bedroom or dining room.', rooms: 1, stairs: false },
    { k: 'rooms', n: 'Several rooms', d: 'Two or more rooms carpeted at the same time.', rooms: 2, stairs: false },
    { k: 'hall', n: 'Hallway', d: 'A hall or landing on its own, no stairs.', rooms: 1, stairs: false, roomName: 'Hallway' },
    { k: 'stairs', n: 'Straight stairs', d: 'One straight flight, no turns.', rooms: 0, stairs: 'straight' },
    { k: 'stairsland', n: 'Stairs and landing', d: 'A straight flight with the landing at the top.', rooms: 0, stairs: 'straight', landing: true },
    { k: 'turning', n: 'Turning or winding stairs', d: 'Quarter turn, half turn or winder treads.', rooms: 0, stairs: 'quarter' },
    { k: 'house', n: 'Whole house', d: 'Rooms, hall, stairs and landing together.', rooms: 2, stairs: 'straight', landing: true }
  ];
  function job() { for (var i = 0; i < JOBS.length; i++) if (JOBS[i].k === S.job) return JOBS[i]; return null; }
  function needsRooms() { var j = job(); return !!(j && j.rooms); }
  function needsStairs() { var j = job(); return !!(j && j.stairs); }
  function isCut() { var j = job(); return !!(j && j.cut); }

  var STEPS_STD = [
    { k: 'job', label: 'Your job' },
    { k: 'measure', label: 'Measurements' },
    { k: 'carpet', label: 'Your carpet' },
    { k: 'underlay', label: 'Underlay' },
    { k: 'extras', label: 'Gripper and bars' },
    { k: 'prep', label: 'Preparation' },
    { k: 'fitting', label: 'Fitting' },
    { k: 'delivery', label: 'Delivery' },
    { k: 'quote', label: 'Your quotation' }
  ];
  /* The cut-to-length job picks the carpet BEFORE the length, because the
     width and the length limit come from the roll. Every other job keeps the
     original order. */
  var STEPS_CUT = [
    { k: 'job', label: 'Your job' },
    { k: 'carpet', label: 'Your carpet' },
    { k: 'measure', label: 'Your length' },
    { k: 'underlay', label: 'Underlay' },
    { k: 'extras', label: 'Gripper and bars' },
    { k: 'prep', label: 'Preparation' },
    { k: 'fitting', label: 'Fitting' },
    { k: 'delivery', label: 'Delivery' },
    { k: 'quote', label: 'Your quotation' }
  ];
  function steps() { return isCut() ? STEPS_CUT : STEPS_STD; }
  function stepKey() { return steps()[stepIndex()].k; }

  /* ------------------------------------------------------ current choices */
  function product() {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].handle === S.prod) return PRODUCTS[i];
    return null;
  }
  function roll() {
    var p = product(); if (!p) return null;
    for (var i = 0; i < p.rolls.length; i++) if (p.rolls[i].id === String(S.roll)) return p.rolls[i];
    return null;
  }
  /* The rolls a customer may be offered: staff have set them Available and
     ticked sell online. Everything else is invisible in the builder. */
  function sellableRolls(p) {
    p = p || product();
    if (!p) return [];
    var out = [];
    for (var i = 0; i < p.rolls.length; i++) if (E.rollSellable(p.rolls[i])) out.push(p.rolls[i]);
    return out;
  }
  /* Which roll we would put the customer on, given what we know right now.
     On a cut-to-length job only rolls of the width the customer picked count. */
  function recommendRoll(p) {
    p = p || product();
    if (!p || p.orderIn) return null;
    var pick = E.chooseRoll(quoteState(), sellableRolls(p), p, RATES, isCut() ? cutWidth() : 0);
    return pick.best ? pick.best.roll : null;
  }

  /* ---- cut to length: the width comes from the roll, never typed ---- */
  function cutWidths(p) {
    p = p || product();
    if (!p) return [];
    if (p.orderIn) return p.orderWidths.slice();
    var out = [], list = sellableRolls(p);
    for (var i = 0; i < list.length; i++) if (out.indexOf(list[i].widthM) === -1) out.push(list[i].widthM);
    return out.sort(function (a, b) { return a - b; });
  }
  /* The only width there is, or the one the customer picked. 0 = not chosen yet. */
  function cutWidth() {
    var ws = cutWidths();
    if (!ws.length) return 0;
    if (ws.length === 1) return ws[0];
    var w = num(S.cutWidth);
    return ws.indexOf(w) === -1 ? 0 : w;
  }
  function cutRolls(p) {
    var w = cutWidth();
    if (!w) return [];
    return sellableRolls(p).filter(function (r) { return r.widthM === w; });
  }
  function longestRoll(list) {
    var best = null;
    for (var i = 0; i < list.length; i++) if (!best || list[i].units > best.units) best = list[i];
    return best;
  }
  /* Keeps the roll on a cut job in step with the width and the length: the
     shortest roll of that width that still fits, or, while nothing fits, the
     longest one so the customer is told what the limit is. A roll the
     customer picked themselves is left alone as long as it is that width. */
  function ensureCutRoll() {
    var p = product();
    if (!p || p.orderIn) return;
    var list = cutRolls(p);
    var cur = roll();
    var keep = cur && list.some(function (r) { return r.id === cur.id; });
    if (keep && !S.rollAuto) return;
    var rec = recommendRoll(p) || longestRoll(list);
    var id = rec ? rec.id : '';
    if (id !== String(S.roll)) { S.roll = id; lastLiveKey = ''; }
    S.rollAuto = true;
  }

  /* Build the engine's area list from the customer's answers. */
  function areas() {
    var out = [];
    if (isCut()) {
      if (num(S.cutLen) > 0) out.push({ kind: 'cut', name: 'Cut to length', lengthM: num(S.cutLen), doorways: 0 });
      return out;
    }
    if (needsRooms()) {
      for (var i = 0; i < S.rooms.length; i++) {
        var r = S.rooms[i];
        if (!num(r.l) || !num(r.w)) continue;
        out.push({
          kind: 'room', name: r.name || ('Room ' + (i + 1)),
          length: num(r.l), width: num(r.w), doorways: num(r.doors),
          extras: (r.extras || []).filter(function (e) { return num(e.depth) && num(e.width); })
            .map(function (e) { return { depth: num(e.depth), width: num(e.width), side: e.side || 'width' }; })
        });
      }
    }
    if (needsStairs() && S.stairs) {
      var st = S.stairs;
      var flights = (st.flights || []).filter(function (f) { return num(f.count) && num(f.tread) && num(f.riser); })
        .map(function (f) { return { label: f.label, count: num(f.count), tread: num(f.tread), riser: num(f.riser) }; });
      var lands = (st.landings || []).filter(function (l) { return num(l.length) && num(l.width); })
        .map(function (l) { return { name: l.name, length: num(l.length), width: num(l.width), doorways: num(l.doorways) }; });
      var winders = (st.winders || []).filter(function (w) { return num(w.count) && num(w.maxTread) && num(w.riser) && num(w.width); })
        .map(function (w) { return { count: num(w.count), maxTread: num(w.maxTread), riser: num(w.riser), width: num(w.width) }; });
      if (flights.length || winders.length) {
        out.push({
          kind: 'stairs', type: st.type, coverage: st.coverage,
          stairWidth: num(st.stairWidth), runnerWidth: num(st.runnerWidth) || 0.69,
          flights: flights, landings: lands, winders: winders
        });
      }
    }
    return out;
  }

  function quoteState() {
    return {
      areas: areas(),
      underlay: S.underlay, gripper: S.gripper, doorBars: num(S.doorBars),
      uplift: S.uplift === true, disposal: S.disposal === true,
      furnitureRooms: num(S.furnitureRooms),
      fitting: S.fitting, route: S.route
    };
  }
  /* The width an order-in job is quoted on: whatever the customer picked, or
     the most economical width if they have not picked one yet. */
  function orderInBest() {
    var p = product();
    if (!p || !p.orderIn) return null;
    return E.orderInOptions(quoteState(), p.orderWidths, p, RATES);
  }
  function orderInRoll() {
    var p = product();
    if (!p || !p.orderIn) return null;
    var w = num(S.orderWidth);
    if (w && p.orderWidths.indexOf(w) === -1) w = 0;
    if (!w) {
      var b = orderInBest();
      w = (b && b.best) ? b.best.roll.widthM : p.orderWidths[0];
    }
    if (!w) return null;
    return { widthM: w, units: null, rollNumber: E.fmtM(w) + 'm width', id: 'orderin-' + w, orderIn: true };
  }
  function calc(forRoll) {
    var p = product();
    if (!p) return null;
    /* A cut job is not priced until the width is known. */
    if (isCut() && !forRoll && !cutWidth()) return null;
    var r = forRoll || (p.orderIn ? orderInRoll() : roll());
    if (!r) return null;
    var prod = p.orderIn
      ? { pricePerM2Pence: p.pricePerM2Pence, classification: p.classification, patternRepeatM: p.patternRepeatM, orderIn: true }
      : p;
    return E.quote(quoteState(), r, prod, RATES);
  }

  /* --------------------------------------------------------- SVG drawing */
  function roomSvg(r) {
    var L = num(r.l), W = num(r.w);
    if (!L || !W) return '';
    var ex = (r.extras || []).filter(function (e) { return num(e.depth) && num(e.width); });
    var boxL = L, boxW = W;
    for (var i = 0; i < ex.length; i++) {
      if (ex[i].side === 'length') boxL += num(ex[i].depth); else boxW += num(ex[i].depth);
    }
    var pad = 34, w = 300, scale = Math.min((w - pad * 2) / boxW, 170 / boxL);
    var rw = W * scale, rh = L * scale, bw = boxW * scale, bh = boxL * scale;
    var h = bh + pad * 2;
    var s = '<svg viewBox="0 0 ' + (bw + pad * 2) + ' ' + h + '" width="100%" style="max-width:' + Math.round(bw + pad * 2) + 'px" role="img" aria-label="Room plan ' + fm(L) + ' by ' + fm(W) + ' metres">';
    s += '<rect x="' + pad + '" y="' + pad + '" width="' + rw + '" height="' + rh + '" fill="#f3ece1" stroke="#9E1B1E" stroke-width="1.5"/>';
    var ox = pad, oy = pad;
    for (i = 0; i < ex.length; i++) {
      var d = num(ex[i].depth) * scale, ew = num(ex[i].width) * scale;
      if (ex[i].side === 'length') s += '<rect x="' + (pad + 10) + '" y="' + (pad + rh) + '" width="' + ew + '" height="' + d + '" fill="#f9f2e6" stroke="#c4a03c" stroke-width="1.2"/>';
      else s += '<rect x="' + (pad + rw) + '" y="' + (pad + 10) + '" width="' + d + '" height="' + ew + '" fill="#f9f2e6" stroke="#c4a03c" stroke-width="1.2"/>';
    }
    s += '<text x="' + (pad + rw / 2) + '" y="' + (pad - 10) + '" text-anchor="middle" font-size="11" fill="#6f6559">' + fm(W) + 'm wide</text>';
    s += '<text x="' + (pad - 8) + '" y="' + (pad + rh / 2) + '" text-anchor="middle" font-size="11" fill="#6f6559" transform="rotate(-90 ' + (pad - 8) + ' ' + (pad + rh / 2) + ')">' + fm(L) + 'm long</text>';
    s += '</svg>';
    return s;
  }

  /* Draws the whole cut as it comes off the roll, area by area. */
  function layoutSvg(q) {
    var R = q.rollWidthM;
    var shelves = [];
    for (var i = 0; i < q.areas.length; i++) {
      var sh = q.areas[i].shelves || [];
      for (var j = 0; j < sh.length; j++) shelves.push({ area: q.areas[i], sh: sh[j] });
    }
    if (!shelves.length) return '';
    var totalCm = q.totalCutCm;
    var W = 620, pad = 30, innerW = W - pad * 2;
    var sc = innerW / (R * 100);
    var hMax = 420;
    var vsc = Math.min(sc, hMax / totalCm);
    var H = totalCm * vsc + pad * 2 + 14;
    var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" width="100%" role="img" aria-label="Cutting layout on a ' + fm(R) + ' metre wide roll">';
    s += '<text x="' + pad + '" y="' + (pad - 10) + '" font-size="11" fill="#6f6559">Roll width ' + fm(R) + 'm across, total cut ' + fm(q.totalCutM) + 'm down the roll</text>';
    var y = pad;
    for (i = 0; i < shelves.length; i++) {
      var sv = shelves[i].sh;
      var sh2 = sv.cutCm * vsc;
      s += '<rect x="' + pad + '" y="' + y + '" width="' + innerW + '" height="' + sh2 + '" fill="none" stroke="#c9bfae" stroke-width="1"/>';
      var x = pad;
      for (var k = 0; k < sv.items.length; k++) {
        var it = sv.items[k];
        var iw = it.acrossCm * sc, ih = Math.min(it.downCm * vsc, sh2);
        var fill = it.kind === 'landing' ? '#9E1B1E' : (it.kind === 'winder' ? '#c4a03c' : '#9E1B1E');
        var op = it.kind === 'landing' ? '.45' : (it.kind === 'winder' ? '.55' : '.85');
        s += '<rect x="' + x + '" y="' + y + '" width="' + iw + '" height="' + ih + '" fill="' + fill + '" fill-opacity="' + op + '"/>';
        if (iw > 60 && ih > 16) {
          s += '<text x="' + (x + 6) + '" y="' + (y + Math.min(ih / 2 + 4, 18)) + '" font-size="10" fill="' + (op === '.85' ? '#fff' : '#1a1510') + '">'
            + esc(it.label) + ' ' + fm(it.downCm / 100) + 'm x ' + fm(it.acrossCm / 100) + 'm</text>';
        }
        x += iw;
      }
      if (sv.spareAcrossCm > 0) {
        var sw = sv.spareAcrossCm * sc;
        s += '<rect x="' + x + '" y="' + y + '" width="' + sw + '" height="' + sh2 + '" fill="none" stroke="#c9bfae" stroke-dasharray="4 3"/>';
        if (sw > 70 && sh2 > 16) {
          s += '<text x="' + (x + 6) + '" y="' + (y + Math.min(sh2 / 2 + 4, 18)) + '" font-size="10" fill="#8b8178">Offcut '
            + fm(sv.cutCm / 100) + 'm x ' + fm(sv.spareAcrossCm / 100) + 'm</text>';
        }
      }
      y += sh2;
    }
    s += '</svg>';
    return s;
  }

  /* ------------------------------------------------------------ rendering */
  function stepIndex() { return Math.max(0, Math.min(steps().length - 1, S.idx || 0)); }

  function render() {
    var STEPS = steps();
    var i = stepIndex();
    var k = STEPS[i].k;
    var html = '';
    if (k === 'job') html = viewJob();
    else if (k === 'measure') html = viewMeasure();
    else if (k === 'carpet') html = viewCarpet();
    else if (k === 'underlay') html = viewUnderlay();
    else if (k === 'extras') html = viewExtras();
    else if (k === 'prep') html = viewPrep();
    else if (k === 'fitting') html = viewFitting();
    else if (k === 'delivery') html = viewDelivery();
    else if (k === 'quote') html = viewQuote();
    $('cq-screen').innerHTML = html;

    var stages = $('cq-stages');
    if (stages) {
      var out = '';
      for (var n = 0; n < STEPS.length; n++) {
        out += '<span class="' + (n === i ? 'on' : (n < i ? 'done' : '')) + '">' + esc(STEPS[n].label) + '</span>';
      }
      stages.innerHTML = out;
    }
    var bar = $('cq-barfill');
    if (bar) bar.style.width = Math.round(((i + 1) / STEPS.length) * 100) + '%';

    var back = $('cq-back'), next = $('cq-next');
    back.hidden = i === 0;
    next.hidden = k === 'quote';
    next.disabled = !canContinue();
    next.textContent = k === 'delivery' ? 'See my quotation' : 'Continue';
    basket();
    save();
    /* On a cut job the roll and the length meet on the measure screen, so
       that is where the live check runs for it. */
    if (k === 'carpet' || k === 'quote' || (k === 'measure' && isCut())) maybeRunLive();
  }

  var lastLiveKey = '';
  function liveKeyNow() {
    var p = product(), q = calc();
    if (!p || !q || !q.ok) return '';
    var r = p.orderIn ? orderInRoll() : roll();
    return p.handle + '|' + (r ? r.id : '') + '|' + q.units;
  }
  function liveSettled() {
    return LIVE.status === 'ok' || LIVE.status === 'short' || LIVE.status === 'otherroll' || LIVE.status === 'overlength' || LIVE.status === 'notoken' || LIVE.status === 'unknown';
  }
  function maybeRunLive(force) {
    var key = liveKeyNow();
    if (!key) { lastLiveKey = ''; LIVE = { status: 'idle', message: '', units: null, at: 0, altRoll: null }; return; }
    if (!force && key === lastLiveKey && liveSettled()) { paintLive(); return; }
    lastLiveKey = key;
    runLive();
  }

  function canContinue() {
    var k = stepKey();
    if (k === 'job') return !!S.job;
    if (k === 'measure') {
      if (!isCut()) return areas().length > 0;
      /* Cut to length: the length has to be a real cut, and it may never be
         more than the roll has. The figure here is the newest one we hold
         (the live one once a check has run); the Storefront check on the
         quotation and on the deposit click stays the final word. */
      var qc = calc();
      if (!qc || !qc.ok) return false;
      if (qc.enoughStock === false) return false;
      /* A live answer only counts against the length it was asked about. */
      if (liveKeyNow() === lastLiveKey && (LIVE.status === 'short' || LIVE.status === 'otherroll' || LIVE.status === 'overlength')) return false;
      return true;
    }
    if (k === 'carpet') {
      if (isCut()) {
        var pc = product();
        return !!(pc && (pc.orderIn || cutWidths(pc).length));
      }
      var q = calc();
      if (!q || !q.ok) return false;
      /* A live check that says the roll is short, or that another roll is
         needed, stops the journey here. A missing token or a failed check does
         not: the customer can still see their quote, but the deposit button
         stays disabled. */
      if (LIVE.status === 'short' || LIVE.status === 'otherroll') return false;
      return true;
    }
    if (k === 'underlay') return !!S.underlay;
    if (k === 'extras') return !!S.gripper;
    if (k === 'prep') return S.uplift !== null && S.disposal !== null;
    if (k === 'fitting') return !!S.fitting;
    if (k === 'delivery') return !!S.route;
    return true;
  }

  function basket() {
    var el = $('cq-basket');
    var q = calc();
    if (!q || !q.ok) { el.hidden = true; return; }
    el.hidden = false;
    var h = '<div class="cq-bk__head">Your quote so far</div><dl class="cq-bk__list">';
    for (var i = 0; i < q.lines.length; i++) {
      h += '<div><dt>' + esc(q.lines[i].key) + '</dt><dd>' + money(q.lines[i].pence) + '</dd></div>';
    }
    h += '</dl><div class="cq-bk__tot"><span>Estimated total</span><b>' + money(q.totalPence) + '</b></div>';
    h += '<p class="cq-small">£50 today, ' + money(q.balancePence) + ' balance in cash or by card.</p>';
    el.innerHTML = h;
  }

  /* ------------------------------------------------------------- step 1 */
  function viewJob() {
    var h = '<h3 class="cq-q">What are you carpeting?</h3>'
      + '<p class="cq-help">Pick the closest match. You can add more rooms or a staircase as you go.</p>'
      + '<div class="cq-cards">';
    for (var i = 0; i < JOBS.length; i++) {
      var j = JOBS[i];
      h += '<button type="button" class="cq-card' + (S.job === j.k ? ' on' : '') + '" data-job="' + j.k + '">'
        + '<span class="cq-card__tick"></span><span class="cq-card__body">'
        + '<span class="cq-card__name">' + esc(j.n) + '</span>'
        + '<span class="cq-card__desc">' + esc(j.d) + '</span>'
        + '</span></button>';
    }
    h += '</div>';
    return h;
  }

  /* ------------------------------------------------------------- step 2 */
  function viewMeasure() {
    if (isCut()) return cutBlock();
    var h = '<h3 class="cq-q">Your measurements</h3>'
      + '<p class="cq-help">Measure into the longest and widest points of each area, including any alcove or bay. '
      + 'We add 0.10m to the length and 0.10m to the width once, so the carpet can be trimmed in neatly.</p>'
      + unitPicker();
    if (needsRooms()) h += roomsBlock();
    if (needsStairs()) h += stairsBlock();
    return h;
  }

  function unitPicker() {
    var u = [['m', 'Metres'], ['cm', 'Centimetres'], ['ft', 'Feet and inches']];
    var h = '<div class="cq-seg" role="group" aria-label="Measurement units">';
    for (var i = 0; i < u.length; i++) {
      h += '<button type="button" data-unit="' + u[i][0] + '" class="' + (S.unit === u[i][0] ? 'on' : '') + '">' + u[i][1] + '</button>';
    }
    h += '</div><p class="cq-small">Whatever you type is converted to metres for the quote.</p>';
    return h;
  }

  function dimField(label, path, val, hint) {
    var suffix = S.unit === 'ft' ? ' (feet, decimals are fine)' : (S.unit === 'cm' ? ' (cm)' : ' (m)');
    return '<label class="cq-f"><span>' + esc(label) + suffix + '</span>'
      + '<input type="number" inputmode="decimal" step="0.01" min="0" data-path="' + path + '" value="' + esc(val) + '">'
      + (hint ? '<small>' + esc(hint) + '</small>' : '') + '</label>';
  }

  /* ---- cut to length: the length screen ---- */
  /* One big field. Whatever unit is picked, the value is stored in metres
     like every other dimension, and shown back in the unit chosen. */
  function cutField() {
    var v = num(S.cutLen);
    var shown = '', step = '0.1', min = '0.5', suffix = ' (metres)';
    if (S.unit === 'cm') { shown = v ? Math.round(v * 100) : ''; step = '10'; min = '50'; suffix = ' (cm)'; }
    else if (S.unit === 'ft') { shown = v ? Math.round((v / 0.3048) * 100) / 100 : ''; step = '0.1'; min = '1.7'; suffix = ' (feet, decimals are fine)'; }
    else { shown = v ? v : ''; }
    return '<label class="cq-f cq-f--wide"><span>Length you need' + suffix + '</span>'
      + '<input type="number" inputmode="decimal" step="' + step + '" min="' + min + '" data-path="cutLen" value="' + esc(shown)
      + '" style="font-size:2.6rem;font-weight:700;min-height:68px;padding:.6rem 1rem" aria-describedby="cq-cuthint"></label>';
  }

  function rollButton(r, rec) {
    return '<button type="button" class="cq-roll' + (String(S.roll) === r.id ? ' on' : '') + '" data-roll="' + esc(r.id) + '">'
      + '<span><b>Roll ' + esc(r.rollNumber) + (rec && rec.id === r.id ? ' (we recommend this one)' : '') + '</b>'
      + '<small>' + fm(r.widthM) + 'm wide, ' + fm(r.lengthM) + 'm left on the roll</small>'
      + (r.where ? '<small>' + esc(r.where) + '</small>' : '') + '</span>'
      + '<span class="cq-roll__tag">' + esc(r.lengthStatus.label) + '</span></button>';
  }

  function cutBlock() {
    var p = product();
    var h = '<h3 class="cq-q">The length you need</h3>'
      + '<p class="cq-help">Tell us the length and we cut it straight off the roll at the full width of the roll. '
      + 'No trimming allowance is added, so you get exactly the length you ask for.</p>';
    if (!p) return h + '<p class="cq-empty">Please go back and choose a carpet first.</p>';
    h += '<p class="cq-small" style="margin:0 0 1.2rem"><b>' + esc(p.title) + '</b>, ' + money(p.pricePerM2Pence) + ' per m²</p>';

    var ws = cutWidths(p), w = cutWidth();
    if (!ws.length) {
      return h + '<p class="cq-empty">Every roll of this carpet is spoken for at the moment. Please go back and choose another carpet, or call the shop.</p>';
    }
    if (ws.length === 1) {
      h += '<div class="cq-ok" style="margin:0 0 1.4rem">' + E.fmtW(ws[0]) + 'm wide, the only width we have of this carpet.</div>';
    } else {
      h += '<h4 class="cq-sh" style="margin-top:0">Which width?</h4>'
        + '<p class="cq-small" style="margin:0 0 .8rem">This carpet is on rolls of more than one width. Pick the width you want and we only look at those rolls.</p>'
        + '<div class="cq-rolls" style="margin:0 0 1.6rem">';
      for (var i = 0; i < ws.length; i++) {
        var wid = ws[i], on = w === wid, left = '';
        if (p.orderIn) left = 'Ordered in from the factory';
        else { var lr0 = longestRoll(sellableRolls(p).filter(function (r) { return r.widthM === wid; })); left = lr0 ? 'up to ' + fm(lr0.lengthM) + 'm left on the roll' : ''; }
        h += '<button type="button" class="cq-roll' + (on ? ' on' : '') + '" data-cutwidth="' + wid + '" style="min-height:64px">'
          + '<span><b style="font-size:1.7rem">' + E.fmtW(wid) + 'm wide</b><small>' + esc(left) + '</small></span>'
          + '<span class="cq-roll__tag">' + (on ? 'Chosen' : 'Choose') + '</span></button>';
      }
      h += '</div>';
    }

    h += unitPicker() + cutField();
    h += '<p class="cq-small" id="cq-cuthint" style="margin:-.4rem 0 0">Cut in 10cm steps. 6.35m becomes 6.40m.';
    if (w) {
      if (p.orderIn) {
        h += '<br>Ordered in from the factory for you, so there is no roll to run out. The length is confirmed with the factory before your order goes ahead. Colours ordered in may carry a small delivery surcharge from the manufacturer, which we confirm with you first.';
      } else {
        var lr = longestRoll(cutRolls(p));
        if (lr) h += '<br>Up to ' + fm(lr.lengthM) + 'm is on roll ' + esc(lr.rollNumber) + ' (' + E.fmtW(lr.widthM) + 'm wide).';
      }
    } else {
      h += '<br>Pick a width above to see how much is on the roll.';
    }
    h += '</p>';

    if (w && !p.orderIn) ensureCutRoll();
    h += '<div id="cq-cutrolls">' + cutRollList(p) + '</div>';
    h += '<div id="cq-cutres">' + cutResult() + '</div>';
    return h;
  }

  /* The rolls of the chosen width, when there is more than one to pick from. */
  function cutRollList(p) {
    if (!p || p.orderIn || !cutWidth()) return '';
    var list = cutRolls(p);
    if (list.length < 2) return '';
    var rec = recommendRoll(p);
    var h = '<div class="cq-group">Which roll?</div><div class="cq-rolls">';
    for (var i = 0; i < list.length; i++) h += rollButton(list[i], rec);
    return h + '</div>';
  }

  function roomsBlock() {
    var j = job();
    if (!S.rooms.length) { S.rooms.push(newRoom(j && j.roomName ? j.roomName : '')); }
    var h = '<h4 class="cq-sh">Rooms</h4>';
    for (var i = 0; i < S.rooms.length; i++) {
      var r = S.rooms[i];
      h += '<div class="cq-room"><div class="cq-room__head"><b>' + esc(r.name || ('Room ' + (i + 1))) + '</b>'
        + (S.rooms.length > 1 ? '<button type="button" class="cq-room__del" data-delroom="' + i + '">Remove</button>' : '')
        + '</div>'
        + '<label class="cq-f"><span>What do you call this room?</span><input type="text" data-path="rooms.' + i + '.name" value="' + esc(r.name) + '" placeholder="Lounge"></label>'
        + '<div class="cq-dims">'
        + dimField('Length', 'rooms.' + i + '.l', r.l)
        + dimField('Width', 'rooms.' + i + '.w', r.w)
        + '</div>'
        + '<div class="cq-step"><span><b>Doorways into this room</b><small>We take 0.80m off the gripper at each doorway.</small></span>'
        + '<span class="cq-stepper"><button type="button" data-inc="rooms.' + i + '.doors" data-by="-1" aria-label="Fewer doorways">&minus;</button>'
        + '<span>' + (num(r.doors)) + '</span>'
        + '<button type="button" data-inc="rooms.' + i + '.doors" data-by="1" aria-label="More doorways">+</button></span></div>';
      for (var x = 0; x < (r.extras || []).length; x++) {
        var ex = r.extras[x];
        h += '<div class="cq-room" style="background:#fff"><div class="cq-room__head"><b>Alcove or bay ' + (x + 1) + '</b>'
          + '<button type="button" class="cq-room__del" data-delextra="' + i + '.' + x + '">Remove</button></div>'
          + '<div class="cq-dims">'
          + dimField('How far it sticks out', 'rooms.' + i + '.extras.' + x + '.depth', ex.depth)
          + dimField('How wide it is', 'rooms.' + i + '.extras.' + x + '.width', ex.width)
          + '</div>'
          + '<div class="cq-seg"><button type="button" data-set="rooms.' + i + '.extras.' + x + '.side" data-val="width" class="' + (ex.side !== 'length' ? 'on' : '') + '">It makes the room wider</button>'
          + '<button type="button" data-set="rooms.' + i + '.extras.' + x + '.side" data-val="length" class="' + (ex.side === 'length' ? 'on' : '') + '">It makes the room longer</button></div>'
          + '</div>';
      }
      h += '<button type="button" class="cq-add" data-addextra="' + i + '">Add an alcove or bay</button>';
      var svg = roomSvg(r);
      if (svg) {
        h += '<figure class="cq-diag">' + svg + '<figcaption>Your room as you have measured it. The carpet is cut into the longest and widest points so it always covers.</figcaption></figure>';
      }
      h += '</div>';
    }
    if (job() && job().rooms > 1) h += '<button type="button" class="cq-add" data-addroom="1">Add another room</button>';
    return h;
  }

  function stairsBlock() {
    if (!S.stairs) S.stairs = newStairs(job().stairs);
    var st = S.stairs;
    var types = [
      ['straight', 'Straight stairs', 'One flight, no turns.'],
      ['quarter', 'Quarter turn', 'One corner, with a small landing at the turn.'],
      ['half', 'Half turn', 'The stairs double back, with a half landing between the flights.'],
      ['winding', 'Winding stairs', 'Tapered treads that turn the corner without a landing.']
    ];
    var h = '<h4 class="cq-sh">Your stairs</h4>'
      + '<figure class="cq-diag">' + stairGuideSvg() + '<figcaption>Tread depth is the flat part you stand on, front to back. Riser height is the upright face between two treads. Measure the width from wall to wall, or the width of the tread if the stairs are open at one side.</figcaption></figure>'
      + '<div class="cq-seg">';
    for (var i = 0; i < types.length; i++) {
      if (job().k !== 'turning' && types[i][0] !== 'straight' && job().k !== 'house') continue;
      h += '<button type="button" data-set="stairs.type" data-val="' + types[i][0] + '" class="' + (st.type === types[i][0] ? 'on' : '') + '">' + types[i][1] + '</button>';
    }
    h += '</div>';
    for (i = 0; i < types.length; i++) if (types[i][0] === st.type) h += '<p class="cq-small">' + esc(types[i][2]) + '</p>';

    var wantTwo = st.type === 'quarter' || st.type === 'half';
    if (wantTwo && st.flights.length < 2) {
      st.flights = [{ label: 'Lower flight', count: st.flights[0] ? st.flights[0].count : '', tread: st.flights[0] ? st.flights[0].tread : '', riser: st.flights[0] ? st.flights[0].riser : '' },
        { label: 'Upper flight', count: '', tread: '', riser: '' }];
    }
    if (!wantTwo && st.flights.length > 1) st.flights = [st.flights[0]];

    for (i = 0; i < st.flights.length; i++) {
      var f = st.flights[i];
      h += '<div class="cq-room"><div class="cq-room__head"><b>' + esc(f.label || 'Staircase') + '</b></div>'
        + '<div class="cq-step"><span><b>How many stairs in this flight?</b><small>Count every step you walk up.</small></span>'
        + '<span class="cq-stepper"><button type="button" data-inc="stairs.flights.' + i + '.count" data-by="-1" aria-label="Fewer stairs">&minus;</button>'
        + '<span>' + (num(f.count) || 0) + '</span>'
        + '<button type="button" data-inc="stairs.flights.' + i + '.count" data-by="1" aria-label="More stairs">+</button></span></div>'
        + '<div class="cq-dims">'
        + dimField('Tread depth', 'stairs.flights.' + i + '.tread', f.tread, 'Front to back, about 0.25m on most stairs.')
        + dimField('Riser height', 'stairs.flights.' + i + '.riser', f.riser, 'The upright face, about 0.20m on most stairs.')
        + '</div></div>';
    }

    h += '<div class="cq-room"><div class="cq-room__head"><b>Width</b></div>'
      + dimField('Stair width', 'stairs.stairWidth', st.stairWidth, 'Wall to wall, or the width of the tread on an open staircase.')
      + '<div class="cq-seg">'
      + '<button type="button" data-set="stairs.coverage" data-val="full" class="' + (st.coverage === 'full' ? 'on' : '') + '">Full width</button>'
      + '<button type="button" data-set="stairs.coverage" data-val="runner" class="' + (st.coverage === 'runner' ? 'on' : '') + '">Runner down the middle</button>'
      + '</div>';
    if (st.coverage === 'runner') {
      var rw = [[0.60, '60cm'], [0.69, '69cm (we recommend this one)'], [0.80, '80cm'], [0, 'Another width']];
      h += '<div class="cq-seg">';
      for (i = 0; i < rw.length; i++) {
        var on = rw[i][0] ? (num(st.runnerWidth) === rw[i][0]) : ([0.6, 0.69, 0.8].indexOf(num(st.runnerWidth)) === -1);
        h += '<button type="button" data-runner="' + rw[i][0] + '" class="' + (on ? 'on' : '') + '">' + rw[i][1] + '</button>';
      }
      h += '</div>';
      if ([0.6, 0.69, 0.8].indexOf(num(st.runnerWidth)) === -1) {
        h += dimField('Finished runner width', 'stairs.runnerWidth', st.runnerWidth);
      }
      h += '<p class="cq-small">Finished runner width is what you see on the stairs. We cut it from the roll 0.10m wider, then bind or edge it back to the finished width.</p>';
    } else {
      h += '<p class="cq-small">Full width means the carpet covers the whole tread. We cut it from the roll 0.10m wider than your stairs so it can be trimmed in at both sides.</p>';
    }
    h += '</div>';

    if (st.type === 'winding') {
      if (!st.winders.length) st.winders.push({ count: 3, maxTread: '', riser: '', width: '' });
      var wd = st.winders[0];
      h += '<div class="cq-room"><div class="cq-room__head"><b>Winder treads</b></div>'
        + '<div class="cq-step"><span><b>How many winder treads?</b><small>The tapered steps that turn the corner.</small></span>'
        + '<span class="cq-stepper"><button type="button" data-inc="stairs.winders.0.count" data-by="-1" aria-label="Fewer winders">&minus;</button>'
        + '<span>' + (num(wd.count) || 0) + '</span>'
        + '<button type="button" data-inc="stairs.winders.0.count" data-by="1" aria-label="More winders">+</button></span></div>'
        + '<div class="cq-dims3">'
        + dimField('Deepest point of the tread', 'stairs.winders.0.maxTread', wd.maxTread)
        + dimField('Riser height', 'stairs.winders.0.riser', wd.riser)
        + dimField('Width at the widest point', 'stairs.winders.0.width', wd.width)
        + '</div>'
        + '<div class="cq-warn"><b>Winding stairs are an estimate</b>Each winder is cut as its own piece. We work each one out at its widest point so there is enough carpet, then confirm the real shapes at the measure. '
        + 'Photographs help a lot. Send them to help@innovationflooringdirect.com with your quote reference and we will check the estimate before anything is cut.</div>'
        + '</div>';
    }

    var wantLanding = job().landing || st.type === 'quarter' || st.type === 'half' || job().k === 'house';
    if (wantLanding && !st.landings.length) {
      st.landings.push({ name: (st.type === 'quarter' || st.type === 'half') ? 'Half landing' : 'Landing', length: '', width: '', doorways: 2 });
    }
    for (i = 0; i < st.landings.length; i++) {
      var l = st.landings[i];
      h += '<div class="cq-room"><div class="cq-room__head"><b>' + esc(l.name || ('Landing ' + (i + 1))) + '</b>'
        + '<button type="button" class="cq-room__del" data-delland="' + i + '">Remove</button></div>'
        + '<label class="cq-f"><span>What do you call this area?</span><input type="text" data-path="stairs.landings.' + i + '.name" value="' + esc(l.name) + '" placeholder="Landing"></label>'
        + '<div class="cq-dims">'
        + dimField('Length', 'stairs.landings.' + i + '.length', l.length)
        + dimField('Width', 'stairs.landings.' + i + '.width', l.width)
        + '</div>'
        + '<div class="cq-step"><span><b>Doorways off this area</b><small>Bedroom and bathroom doors off the landing.</small></span>'
        + '<span class="cq-stepper"><button type="button" data-inc="stairs.landings.' + i + '.doorways" data-by="-1" aria-label="Fewer doorways">&minus;</button>'
        + '<span>' + (num(l.doorways) || 0) + '</span>'
        + '<button type="button" data-inc="stairs.landings.' + i + '.doorways" data-by="1" aria-label="More doorways">+</button></span></div>'
        + '</div>';
    }
    h += '<button type="button" class="cq-add" data-addland="1">Add a landing, upper hall or lower hall</button>';
    h += '<div class="cq-disc">' + esc(E.DISCLAIMER) + '</div>';
    return h;
  }

  function stairGuideSvg() {
    return '<svg viewBox="0 0 420 190" width="100%" role="img" aria-label="How to measure a stair tread and riser">'
      + '<g fill="none" stroke="#9E1B1E" stroke-width="2">'
      + '<path d="M40 160 h70 v-34 h70 v-34 h70 v-34 h70 v-34 h60"/></g>'
      + '<g stroke="#6f6559" stroke-width="1">'
      + '<line x1="110" y1="140" x2="180" y2="140"/><line x1="110" y1="134" x2="110" y2="146"/><line x1="180" y1="134" x2="180" y2="146"/>'
      + '<line x1="188" y1="126" x2="188" y2="92"/><line x1="182" y1="126" x2="194" y2="126"/><line x1="182" y1="92" x2="194" y2="92"/>'
      + '</g>'
      + '<text x="145" y="158" text-anchor="middle" font-size="12" fill="#3a3028">Tread depth</text>'
      + '<text x="200" y="112" font-size="12" fill="#3a3028">Riser height</text>'
      + '<text x="40" y="182" font-size="12" fill="#8b8178">Measure one tread and one riser. All the steps are almost always the same.</text>'
      + '</svg>';
  }

  /* ------------------------------------------------------------- step 3 */
  function viewCarpet() {
    var h = '<h3 class="cq-q">Choose your carpet</h3>'
      + (isCut()
        ? '<p class="cq-help">These are the rolls we have on the racks in Clydebank right now. Pick a carpet, then on the next screen tell us the length. The width and the length limit come from the roll.</p>'
        : '<p class="cq-help">These are the rolls we have on the racks in Clydebank right now. Pick a range, then pick the roll it comes off.</p>');
    var offerAll = PRODUCTS.filter(function (p) { return p.orderIn || sellableRolls(p).length; });
    var shop = offerAll.filter(function (p) { return !p.orderIn && !p.allRemnant; });
    var rem = offerAll.filter(function (p) { return !p.orderIn && p.allRemnant; });
    var order = offerAll.filter(function (p) { return p.orderIn; });
    if (!offerAll.length) return h + '<p class="cq-empty">We have no carpet we can quote online at the moment. Please call the shop and we will tell you what is on the floor today.</p>';
    if (shop.length || rem.length) {
      h += '<div class="cq-group">On the roll in our Clydebank store</div>';
      if (shop.length) h += cardGrid(shop);
      if (rem.length) h += '<div class="cq-group" style="border-top:0;padding-top:.6rem;margin-top:1.4rem">Remnants and short rolls</div>' + cardGrid(rem);
    }
    if (order.length) {
      h += '<div class="cq-group">Order-in ranges</div>'
        + '<p class="cq-help">These are ordered in from the factory for you. Nothing is held on a rack here, so the length is confirmed with the factory before your order goes ahead. Colours ordered in may carry a small delivery surcharge from the manufacturer, which we confirm with you first.</p>'
        + cardGrid(order);
    }
    var p = product();
    if (isCut()) {
      /* The roll and the length meet on the next screen. */
      if (p) {
        var wsc = cutWidths(p);
        h += '<div class="cq-ok">' + esc(p.title) + ' chosen'
          + (wsc.length ? ', ' + wsc.map(function (x) { return E.fmtW(x) + 'm'; }).join(' and ') + ' wide. Continue to enter your length.' : '. Every roll of it is spoken for at the moment, so please pick another carpet or call the shop.')
          + '</div>';
      }
      return h;
    }
    if (p && p.orderIn) {
      h += '<div class="cq-group">Which roll width?</div>'
        + '<p class="cq-help">' + esc(E.ORDER_IN_NOTE) + '</p>'
        + '<div class="cq-rolls">';
      var chosen = orderInRoll();
      for (var w = 0; w < p.orderWidths.length; w++) {
        var wid = p.orderWidths[w];
        var on = chosen && chosen.widthM === wid;
        h += '<button type="button" class="cq-roll' + (on ? ' on' : '') + '" data-orderwidth="' + wid + '">'
          + '<span><b>' + fm(wid) + 'm wide</b><small>Ordered in from the factory</small></span>'
          + '<span class="cq-roll__tag">' + (on ? 'Chosen' : 'Choose') + '</span></button>';
      }
      h += '</div>' + cutResult();
    } else if (p) {
      var offer = sellableRolls(p);
      var rec = recommendRoll(p);
      h += '<div class="cq-group">Which roll?</div>';
      if (!offer.length) {
        h += '<p class="cq-empty">Every roll of this carpet is spoken for at the moment. Please call the shop and we will tell you when the next one is on the rack.</p>';
      }
      h += '<div class="cq-rolls">';
      for (var i = 0; i < offer.length; i++) h += rollButton(offer[i], rec);
      h += '</div>';
      h += cutResult();
    }
    return h;
  }

  function cardGrid(list) {
    var h = '<div class="cq-fgrid">';
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      var offerable = p.orderIn ? [] : sellableRolls(p);
      var widths = (p.orderIn ? p.widths : offerable.map(function (r) { return r.widthM; })
        .filter(function (v, k, a) { return a.indexOf(v) === k; }).sort())
        .map(function (w) { return fm(w) + 'm'; }).join(' and ');
      var longest = offerable.length ? Math.max.apply(null, offerable.map(function (r) { return r.lengthM; })) : 0;
      var wheres = [];
      for (var wq = 0; wq < offerable.length; wq++) {
        var ww = offerable[wq].where;
        if (ww && wheres.indexOf(ww) === -1) wheres.push(ww);
      }
      h += '<div class="cq-fc' + (S.prod === p.handle ? ' on' : '') + '">'
        + '<span class="cq-fc__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '')
        + (p.allRemnant ? '<span class="cq-fc__badge">Remnant</span>' : '')
        + (p.orderIn ? '<span class="cq-fc__badge">Order-in</span>' : '') + '</span>'
        + '<div class="cq-fc__b"><b>' + esc(p.title) + '</b>'
        + '<div class="cq-fc__price">' + money(p.pricePerM2Pence) + ' <i>per m²</i></div>'
        + '<div class="cq-fc__spec">' + esc(widths) + ' wide'
        + (p.orderIn ? '' : ', up to ' + fm(longest) + 'm left') + '</div>'
        + (p.orderIn ? '<div class="cq-fc__spec">' + esc(E.ORDER_IN_NOTE) + '</div>' : '')
        + (wheres.length ? '<div class="cq-fc__spec">' + esc(wheres.join(' ')) + '</div>' : '')
        + (p.pileStyle || p.feel.length ? '<div class="cq-fc__spec">' + esc([p.pileStyle].concat(p.feel).filter(Boolean).join(', ')) + '</div>' : '')
        + (p.rooms.length ? '<div class="cq-fc__spec">Best for ' + esc(p.rooms.join(', ').toLowerCase()) + '</div>' : '')
        + '<div class="cq-fc__att">' + (p.stairsSuitable ? 'Suitable for stairs' : 'Not recommended for stairs')
        + (p.heavyDomestic ? ', heavy domestic' : '') + '</div>'
        + (p.inStore && !p.orderIn ? '<div class="cq-fc__att">In our Clydebank store, ready to collect today</div>' : '')
        + '<div class="cq-fc__acts"><button type="button" class="cq-fc__go" data-prod="' + esc(p.handle) + '">'
        + (S.prod === p.handle ? 'Chosen' : 'Choose this carpet') + '</button>'
        + (p.url ? '<a class="cq-fc__view" href="' + esc(p.url) + '">See the full details</a>' : '')
        + '</div></div></div>';
    }
    return h + '</div>';
  }

  function cutResult() {
    var p = product();
    var r = p && p.orderIn ? orderInRoll() : roll();
    if (!p) return '';
    if (!r) return '<p class="cq-help">Pick a roll above to see your cut.</p>';
    if (needsStairs() && !p.stairsSuitable) {
      return '<div class="cq-warn"><b>This carpet is not recommended for stairs</b>Its make-up will not wear well on a staircase. Please choose another range, or call the shop and we will suggest one that suits.</div>';
    }
    var q = calc();
    if (!q) return '';
    if (!q.ok) {
      if (q.reason === 'short') return '<div class="cq-stop"><b>That is too short to cut</b><p>' + esc(q.message) + '</p></div>';
      return '<div class="cq-stop"><b>We cannot work this one out online</b><p>' + esc(q.message) + '</p></div>';
    }

    if (isCut()) return cutCard(q, p, r);

    var h = '<div class="cq-res">';
    for (var i = 0; i < q.areas.length; i++) {
      var a = q.areas[i];
      h += '<p class="cq-res__say">' + esc(a.sentence) + '</p>';
      if (a.kind === 'stairs') h += '<p class="cq-res__why">' + esc(E.widthLabel(a)) + '</p>';
      else h += '<p class="cq-res__why">' + esc(a.why) + '</p>';
      if (a.join) h += '<div class="cq-warn"><b>A join is needed</b>Your room is wider than this roll, so the carpet comes in two widths laid the same way and joined. We put the join where it shows least and agree it with you before cutting.</div>';
    }
    h += '<dl class="cq-res__rows">'
      + row('Floor area we will fit', fm(q.floorM2) + ' m²')
      + row('Roll width', fm(q.rollWidthM) + ' m')
      + row('Recommended linear cut', fm(q.totalCutM) + ' m')
      + row('Chargeable carpet area', fm(q.chargeableM2) + ' m²')
      + row('Carpet price', money(q.carpetPence))
      + (p.orderIn ? row('Supply', E.ORDER_IN_NOTE) : row('Left on roll ' + esc(r.rollNumber), fm(r.lengthM) + ' m'))
      + (!p.orderIn && r.where ? row('Where it is', r.where) : '')
      + '</dl>';
    /* The live figure, not the one the page was built with, decides this. */
    h += '<div id="cq-livebox">' + liveHtml() + '</div>';
    var lay = layoutSvg(q);
    if (lay) h += '<figure class="cq-diag">' + lay + '<figcaption>How your cut comes off the roll. The dashed areas are offcuts, which are yours to keep.</figcaption></figure>';

    if (q.areas.length > 1) {
      var plan = E.cuttingPlan(q.areas, q.rollWidthM);
      h += '<div class="cq-group">Your cutting plan</div><table class="cq-cmp"><thead><tr><th>Area</th><th class="n">Cut</th><th>Offcut left</th></tr></thead><tbody>';
      for (i = 0; i < plan.rows.length; i++) {
        var pr = plan.rows[i];
        h += '<tr><td>' + esc(pr.name) + '</td><td class="n">' + fm(pr.cutM) + ' m</td><td>'
          + (pr.offcutWidthM > 0 ? fm(pr.offcutLengthM) + 'm x ' + fm(pr.offcutWidthM) + 'm' : 'None')
          + (pr.couldUseOffcutFrom ? '<br><small>The offcut from ' + esc(pr.couldUseOffcutFrom) + ' would cover this area.</small>' : '')
          + (pr.offcutNote ? '<br><small>' + esc(pr.offcutNote) + '</small>' : '')
          + '</td></tr>';
      }
      h += '</tbody></table>';
    }

    if (p.orderIn && p.orderWidths.length > 1) {
      var oi = E.orderInOptions(quoteState(), p.orderWidths, p, RATES);
      h += '<div class="cq-group">The same job on each width this carpet comes in</div>'
        + '<table class="cq-cmp"><thead><tr><th>Width</th><th class="n">Cut</th><th class="n">Carpet area</th><th class="n">Carpet</th><th>Joins</th></tr></thead><tbody>';
      for (var oj = 0; oj < oi.options.length; oj++) {
        var oo = oi.options[oj];
        var isBest = oi.best && oi.best.roll.widthM === oo.roll.widthM;
        h += '<tr class="' + (isBest ? 'best' : '') + '"><td>' + fm(oo.roll.widthM) + 'm</td>';
        if (oo.quote.ok) {
          h += '<td class="n">' + fm(oo.quote.totalCutM) + 'm</td><td class="n">' + fm(oo.quote.chargeableM2) + ' m²</td>'
            + '<td class="n">' + money(oo.quote.carpetPence) + '</td><td>'
            + (oo.quote.joins ? oo.quote.joins + ' join' + (oo.quote.joins > 1 ? 's' : '') : 'None')
            + (isBest ? ', we recommend this one' : '') + '</td></tr>';
        } else {
          h += '<td class="n">-</td><td class="n">-</td><td class="n">-</td><td>Cannot be quoted online</td></tr>';
        }
      }
      h += '</tbody></table>';
    }

    /* Roll comparison across every width this range has in stock. */
    if (!p.orderIn && p.widths.length > 1) {
      var byWidth = {}, list = [];
      for (i = 0; i < p.rolls.length; i++) { if (!byWidth[p.rolls[i].widthM]) { byWidth[p.rolls[i].widthM] = 1; list.push(p.rolls[i]); } }
      var cmp = E.compareWidths(quoteState(), list, p, RATES);
      h += '<div class="cq-group">The same job on each roll width</div><table class="cq-cmp"><thead><tr><th>Roll</th><th class="n">Width</th><th class="n">Cut</th><th class="n">Carpet</th><th>Joins</th></tr></thead><tbody>';
      for (i = 0; i < cmp.options.length; i++) {
        var o = cmp.options[i];
        var best = cmp.best && cmp.best.roll.id === o.roll.id;
        h += '<tr class="' + (best ? 'best' : '') + '"><td>' + esc(o.roll.rollNumber) + '</td><td class="n">' + fm(o.roll.widthM) + 'm</td>';
        if (o.quote.ok) {
          h += '<td class="n">' + fm(o.quote.totalCutM) + 'm</td><td class="n">' + money(o.quote.carpetPence) + '</td><td>'
            + (o.quote.joins ? o.quote.joins + ' join' + (o.quote.joins > 1 ? 's' : '') : 'None') + (best ? ', we recommend this one' : '') + '</td></tr>';
        } else {
          h += '<td class="n">-</td><td class="n">-</td><td>Cannot be quoted online</td></tr>';
        }
      }
      h += '</tbody></table>';
    }
    if (q.hasStairs) h += '<div class="cq-disc">' + esc(E.DISCLAIMER) + '</div>';
    h += '</div>';
    return h;
  }

  function row(k, v) { return '<div><dt>' + esc(k) + '</dt><dd>' + esc(v) + '</dd></div>'; }

  /* "6.40 m (6.35 m entered, rounded up to the next 10cm)" */
  function lengthRequested(q) {
    var bits = [];
    for (var i = 0; i < q.areas.length; i++) {
      var a = q.areas[i];
      if (a.kind !== 'cut') continue;
      bits.push(fm(a.cutM) + ' m' + (a.rounded ? ' (' + fm(a.requestedM) + ' m entered, rounded up to the next 10cm)' : ''));
    }
    return bits.join(' | ');
  }

  /* The cut-to-length result. The roll number, "Where it is" and the live
     box are exactly the ones the room and stair jobs show. */
  function cutCard(q, p, r) {
    var a = null;
    for (var i = 0; i < q.areas.length; i++) if (q.areas[i].kind === 'cut') { a = q.areas[i]; break; }
    if (!a) return '';
    var h = '<div class="cq-res">'
      + '<p class="cq-res__say">Your cut: ' + fm(a.cutM) + 'm × ' + E.fmtW(q.rollWidthM) + 'm = ' + fm(q.chargeableM2) + ' m² · ' + money(q.carpetPence) + '</p>'
      + '<p class="cq-res__why">' + esc(a.sentence) + ' ' + esc(a.why) + '</p>';
    var leftAfter = (!p.orderIn && r.units != null) ? Math.round(r.units - q.units) / 10 : null;
    h += '<dl class="cq-res__rows">'
      + row('Length requested', lengthRequested(q))
      + row('Roll width', fm(q.rollWidthM) + ' m')
      + row('Chargeable carpet area', fm(q.chargeableM2) + ' m²')
      + row('Carpet price', money(q.carpetPence))
      + (p.orderIn ? row('Supply', E.ORDER_IN_NOTE) : row('Roll number', r.rollNumber))
      + (leftAfter == null ? '' : row('Left on the roll after your cut', leftAfter >= 0 ? fm(leftAfter) + ' m' : 'Not enough on this roll, it has ' + fm(r.lengthM) + ' m'))
      + (!p.orderIn && r.where ? row('Where it is', r.where) : '')
      + '</dl>';
    /* The live figure, not the one the page was built with, decides this.
       Between keystrokes the last answer belongs to another length, so it is
       not shown until the next check has run. */
    var liveFresh = liveKeyNow() === lastLiveKey;
    h += '<div id="cq-livebox">' + (liveFresh ? liveHtml() : '') + '</div>';
    if (!p.orderIn && q.enoughStock === false) {
      /* The newest figure we hold says it is short. Once the live check has
         answered for this length, paintLive() hides this and its own box
         carries the same message, so the customer never sees it twice. */
      var liveSaysNo = liveFresh && (LIVE.status === 'overlength' || LIVE.status === 'short' || LIVE.status === 'otherroll');
      h += '<div class="cq-stop" id="cq-cutover"' + (liveSaysNo ? ' hidden' : '') + '><b>That is more than this roll has</b><p>' + esc(overLengthMessage(r.units)) + '</p></div>';
    }
    var lay = layoutSvg(q);
    if (lay) h += '<figure class="cq-diag">' + lay + '<figcaption>Your cut as it comes off the roll, the full width of the roll by the length you asked for.</figcaption></figure>';
    return h + '</div>';
  }

  function overLengthMessage(units) {
    var left = fm(Math.max(units || 0, 0) / 10);
    return 'This roll has ' + left + 'm left. Enter ' + left + 'm or less, or choose another roll.';
  }

  /* ------------------------------------------------------------- step 4 */
  function viewUnderlay() {
    var p = product(), q = calc();
    var m2 = q ? Math.ceil((q.floorM2 * 1.05) - 0.00001) : 0;
    var rec = p ? p.recommendedUnderlay : '';
    var opts = [
      { k: '10mm', n: '10mm underlay', d: 'A good all-round thickness for bedrooms, lounges and stairs. Softer underfoot, quieter, and it takes the wear off the carpet backing so the carpet lasts longer.', rate: RATES.underlay10 },
      { k: '12mm', n: '12mm underlay', d: 'Thicker and softer again. Best in a lounge or bedroom where you want the most comfort. Not always right on stairs, so we will confirm at the measure.', rate: RATES.underlay12 },
      { k: 'have', n: 'I already have underlay', d: 'We will check it is in good condition when we measure. If it needs replacing we will tell you the cost before any work starts.', rate: 0 },
      { k: 'none', n: 'No underlay', d: 'Carpet laid straight onto the floor. It will feel harder and wear faster.', rate: 0 }
    ];
    var h = '<h3 class="cq-q">Underlay</h3>'
      + '<p class="cq-help">Worked out on the floor area you are covering, plus 5% for cutting, rounded up to the next whole square metre. '
      + (q ? 'That is <b>' + m2 + ' m²</b> for your job.' : '') + '</p>';
    if (rec && (rec === '10mm' || rec === '12mm' || rec === 'Either')) {
      h += '<div class="cq-ok">We recommend ' + esc(rec === 'Either' ? '10mm or 12mm' : rec) + ' with this carpet.</div>';
    }
    h += '<div class="cq-cards">';
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var cost = o.rate ? money(o.rate * m2) : 'No charge';
      h += '<button type="button" class="cq-card' + (S.underlay === o.k ? ' on' : '') + '" data-set="underlay" data-val="' + o.k + '">'
        + '<span class="cq-card__tick"></span><span class="cq-card__body">'
        + '<span class="cq-card__name">' + esc(o.n) + '</span>'
        + '<span class="cq-card__desc">' + esc(o.d) + '</span>'
        + '<span class="cq-card__adds' + (o.rate ? '' : ' is-free') + '">' + (o.rate ? money(o.rate) + ' per m², ' + m2 + ' m² = ' + cost : cost) + '</span>'
        + '</span></button>';
    }
    return h + '</div>';
  }

  /* ------------------------------------------------------------- step 5 */
  function viewExtras() {
    var q = calc();
    var acc = q ? E.accessories({
      rates: RATES, floorM2: q.floorM2,
      rooms: q.areas.filter(function (a) { return a.kind === 'room' || a.kind === 'cut'; }),
      landings: [].concat.apply([], q.areas.filter(function (a) { return a.kind === 'stairs'; }).map(function (a) { return a.landings; })),
      stairCount: q.areas.reduce(function (t, a) { return t + (a.stairCount || 0); }, 0),
      stairWidthM: q.hasStairs ? (q.areas.filter(function (a) { return a.kind === 'stairs'; })[0] || {}).stairWidthM : 0,
      underlay: 'none', gripper: 'new', doorBars: 0
    }) : null;
    var lengths = acc ? acc.gripper.lengths : 0;
    var metres = acc ? acc.gripper.metres : 0;
    var opts = [
      { k: 'new', n: 'New gripper', d: 'Fresh gripper all round. Nails and holds the carpet tight at every edge.', cost: lengths * RATES.gripper },
      { k: 'reuse', n: 'Reuse the gripper that is there', d: 'We check it at the measure. Where it is sound we reuse it and there is nothing to pay. Anything broken or rusted is replaced and we tell you first.', cost: 0 },
      { k: 'none', n: 'No gripper needed', d: 'Only pick this if you know the gripper is already right for a new carpet.', cost: 0 }
    ];
    var h = '<h3 class="cq-q">Gripper and door bars</h3>'
      + '<p class="cq-help">Gripper comes in ' + fm(1.52) + 'm lengths. Your job needs about <b>' + fm(metres) + 'm</b> around the edges, which is <b>' + lengths + ' lengths</b>. '
      + 'We take 0.80m off at every doorway because the door bar goes there instead.</p>'
      + '<div class="cq-cards">';
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      h += '<button type="button" class="cq-card' + (S.gripper === o.k ? ' on' : '') + '" data-set="gripper" data-val="' + o.k + '">'
        + '<span class="cq-card__tick"></span><span class="cq-card__body">'
        + '<span class="cq-card__name">' + esc(o.n) + '</span><span class="cq-card__desc">' + esc(o.d) + '</span>'
        + '<span class="cq-card__adds' + (o.cost ? '' : ' is-free') + '">' + (o.cost ? money(RATES.gripper) + ' per length, ' + lengths + ' lengths = ' + money(o.cost) : 'No charge') + '</span>'
        + '</span></button>';
    }
    h += '</div>';
    h += '<h4 class="cq-sh">Door bars</h4>'
      + '<p class="cq-help">A door bar finishes the carpet at a doorway where it meets another floor. ' + money(RATES.doorbar) + ' each. '
      + 'We confirm the colour and profile with you before the order goes ahead.</p>'
      + '<div class="cq-step"><span><b>How many door bars?</b><small>One for each doorway that needs finishing.</small></span>'
      + '<span class="cq-stepper"><button type="button" data-inc="doorBars" data-by="-1" aria-label="Fewer door bars">&minus;</button>'
      + '<span>' + num(S.doorBars) + '</span>'
      + '<button type="button" data-inc="doorBars" data-by="1" aria-label="More door bars">+</button></span></div>';
    if (num(S.doorBars) > 0) {
      h += '<div class="cq-ok">' + num(S.doorBars) + ' door bars = ' + money(num(S.doorBars) * RATES.doorbar) + '</div>';
      h += '<label class="cq-f cq-f--wide"><span>What is the floor on the other side of those doorways?</span>'
        + '<input type="text" data-path="doorBarOther" value="' + esc(S.doorBarOther) + '" placeholder="Carpet, laminate, tile or other"></label>';
    }
    return h;
  }

  /* ------------------------------------------------------------- step 6 */
  function viewPrep() {
    var q = calc();
    var area = q ? q.floorM2 : 0;
    var roomCount = q ? q.areas.filter(function (a) { return a.kind === 'room'; }).length : 0;
    var h = '<h3 class="cq-q">Getting the room ready</h3>'
      + '<p class="cq-help">All of these are worked out on the floor area you are covering, ' + fm(area) + ' m².</p>'
      + '<h4 class="cq-sh">Taking up your old floor</h4><div class="cq-cards">'
      + yesNo('uplift', 'Yes, please take it up', 'We lift the old carpet and gripper and leave the floor ready. ' + money(RATES.uplift) + ' per m², ' + money(Math.round(area * RATES.uplift)) + ' for your job.',
        'No, the floor is already clear', 'Nothing to pay.')
      + '</div>'
      + '<h4 class="cq-sh">Taking the old floor away</h4><div class="cq-cards">'
      + yesNo('disposal', 'Yes, take it away', 'We load it and dispose of it properly. ' + money(RATES.disposal) + ' per m², ' + money(Math.round(area * RATES.disposal)) + ' for your job.',
        'No, we will deal with it', 'Nothing to pay.')
      + '</div>';
    if (roomCount) {
      h += '<h4 class="cq-sh">Furniture</h4>'
        + '<p class="cq-help">' + money(RATES.furniture) + ' per room for clearing and putting back furniture. '
        + 'A single sofa or a bed that can be slid from side to side is free, so you do not need to count a room that only has one of those.</p>'
        + '<div class="cq-step"><span><b>How many rooms need furniture moved?</b><small>Leave it at zero if you can clear them yourself.</small></span>'
        + '<span class="cq-stepper"><button type="button" data-inc="furnitureRooms" data-by="-1" aria-label="Fewer rooms">&minus;</button>'
        + '<span>' + num(S.furnitureRooms) + '</span>'
        + '<button type="button" data-inc="furnitureRooms" data-by="1" aria-label="More rooms">+</button></span></div>';
      if (num(S.furnitureRooms)) h += '<div class="cq-ok">' + num(S.furnitureRooms) + ' rooms = ' + money(num(S.furnitureRooms) * RATES.furniture) + '</div>';
    }
    return h;
  }

  function yesNo(key, yn, yd, nn, nd) {
    var v = S[key];
    return '<button type="button" class="cq-card' + (v === true ? ' on' : '') + '" data-bool="' + key + '" data-val="1">'
      + '<span class="cq-card__tick"></span><span class="cq-card__body"><span class="cq-card__name">' + esc(yn) + '</span>'
      + '<span class="cq-card__desc">' + esc(yd) + '</span></span></button>'
      + '<button type="button" class="cq-card' + (v === false ? ' on' : '') + '" data-bool="' + key + '" data-val="0">'
      + '<span class="cq-card__tick"></span><span class="cq-card__body"><span class="cq-card__name">' + esc(nn) + '</span>'
      + '<span class="cq-card__desc">' + esc(nd) + '</span></span></button>';
  }

  /* ------------------------------------------------------------- step 7 */
  function viewFitting() {
    var q = calc();
    var area = q ? q.floorM2 : 0;
    var hasStairs = q ? q.hasStairs : false;
    var calcP = Math.round(area * RATES.fitting);
    var min = hasStairs ? RATES.fitMinStairs : RATES.fitMinRooms;
    var charge = Math.max(calcP, min);
    var h = '<h3 class="cq-q">Would you like us to fit it?</h3>'
      + '<p class="cq-help">Fitting is ' + money(RATES.fitting) + ' per m² on the floor area you are covering. '
      + 'There is a minimum charge of ' + money0(RATES.fitMinRooms) + ' for rooms, and ' + money0(RATES.fitMinStairs) + ' when the job includes stairs, '
      + 'because a fitter still loses a day on a small job. You pay whichever is higher, never both.</p>'
      + '<div class="cq-cards">'
      + '<button type="button" class="cq-card' + (S.fitting === 'yes' ? ' on' : '') + '" data-set="fitting" data-val="yes">'
      + '<span class="cq-card__tick"></span><span class="cq-card__body"><span class="cq-card__name">Yes, please fit it</span>'
      + '<span class="cq-card__desc">' + fm(area) + ' m² at ' + money(RATES.fitting) + ' per m² is ' + money(calcP) + '. '
      + (charge > calcP ? 'The ' + money0(min) + ' minimum applies, so fitting is ' + money(charge) + '.' : 'That is what you pay.')
      + ' Delivery is included free when we fit.</span>'
      + '<span class="cq-card__adds">' + money(charge) + '</span></span></button>'
      + '<button type="button" class="cq-card' + (S.fitting === 'no' ? ' on' : '') + '" data-set="fitting" data-val="no">'
      + '<span class="cq-card__tick"></span><span class="cq-card__body"><span class="cq-card__name">No, supply only</span>'
      + '<span class="cq-card__desc">We cut the carpet and you arrange the fitting. Underlay, gripper and door bars still come with the order if you have asked for them.</span>'
      + '<span class="cq-card__adds is-free">No charge</span></span></button>'
      + '</div>';
    return h;
  }

  /* ------------------------------------------------------------- step 8 */
  function viewDelivery() {
    var fitted = S.fitting === 'yes';
    var h = '<h3 class="cq-q">Delivery or collection?</h3>'
      + '<p class="cq-help">Collection from our Clydebank store is always free. Local delivery is ' + money0(RATES.delivery) + ', and it is free when we are fitting for you.</p>'
      + '<div class="cq-cards">'
      + '<button type="button" class="cq-card' + (S.route === 'collect' ? ' on' : '') + '" data-set="route" data-val="collect">'
      + '<span class="cq-card__tick"></span><span class="cq-card__body"><span class="cq-card__name">I will collect it</span>'
      + '<span class="cq-card__desc">Pick it up from our Clydebank store once it is cut. We will ring you when it is ready.</span>'
      + '<span class="cq-card__adds is-free">Free</span></span></button>'
      + '<button type="button" class="cq-card' + (S.route === 'delivery' ? ' on' : '') + '" data-set="route" data-val="delivery">'
      + '<span class="cq-card__tick"></span><span class="cq-card__body"><span class="cq-card__name">Local delivery</span>'
      + '<span class="cq-card__desc">' + (fitted ? 'Included free because we are fitting for you.' : 'Delivered to your door in our local area.') + '</span>'
      + '<span class="cq-card__adds' + (fitted ? ' is-free' : '') + '">' + (fitted ? 'Free with fitting' : money(RATES.delivery)) + '</span></span></button>'
      + '</div>';
    return h;
  }

  /* ------------------------------------------------------------- step 9 */
  function viewQuote() {
    var p = product(), q = calc();
    var r = p && p.orderIn ? orderInRoll() : roll();
    if (!q || !q.ok) return '<div class="cq-stop"><b>Your quote is not finished</b><p>Please go back and add your measurements and choose a carpet.</p></div>';
    var h = '<h3 class="cq-q">Your quotation</h3>'
      + '<p class="cq-help">Quote reference ' + esc(mkref()) + '. Everything below is what we hold on file for you.</p>';

    h += '<dl class="cq-res__rows">'
      + row('Carpet', p.title)
      + (p.orderIn ? row('Supply', E.ORDER_IN_NOTE) : row('Roll number', r.rollNumber))
      + (!p.orderIn && r.where ? row('Where it is', r.where) : '')
      + row('Roll width', fm(q.rollWidthM) + ' m');
    for (var i = 0; i < q.areas.length; i++) {
      var a = q.areas[i];
      if (a.kind === 'room') {
        h += row(a.name, fm(a.roomLM) + 'm x ' + fm(a.roomWM) + 'm, ' + fm(a.floorM2) + ' m², cut ' + fm(a.cutM) + 'm');
      } else if (a.kind === 'cut') {
        h += row(a.name, fm(a.cutM) + 'm x ' + E.fmtW(a.rollWidthM) + 'm = ' + fm(a.chargeableM2) + ' m², cut straight off the roll, no join, no trimming allowance');
      } else {
        for (var f = 0; f < a.strips.length; f++) {
          h += row(a.strips[f].label, a.strips[f].stairs + ' stairs, tread ' + fm(a.strips[f].treadM) + 'm, riser ' + fm(a.strips[f].riserM) + 'm, strip ' + fm(a.strips[f].lengthM) + 'm x ' + fm(a.strips[f].cutWidthM) + 'm');
        }
        for (f = 0; f < a.winders.length; f++) {
          h += row(a.winders[f].label, fm(a.winders[f].downM) + 'm x ' + fm(a.winders[f].acrossM) + 'm');
        }
        for (f = 0; f < a.landings.length; f++) {
          h += row(a.landings[f].name, fm(a.landings[f].lengthM) + 'm x ' + fm(a.landings[f].widthM) + 'm, ' + fm(a.landings[f].floorM2) + ' m²');
        }
        h += row('Stair width', a.coverage === 'runner' ? 'Finished runner width ' + fm(a.finishedWidthM) + 'm, cut from the roll at ' + fm(a.cutWidthM) + 'm' : 'Full width, ' + fm(a.stairWidthM) + 'm across, cut from the roll at ' + fm(a.cutWidthM) + 'm');
      }
    }
    h += row('Floor area we will fit', fm(q.floorM2) + ' m²')
      + (q.hasCut ? row('Length requested', lengthRequested(q)) : '')
      + row('Recommended linear cut', fm(q.totalCutM) + ' m')
      + row('Chargeable carpet area', fm(q.chargeableM2) + ' m²')
      + row('Carpet price', money(q.carpetPence))
      + '</dl>';

    h += '<ul class="cq-lines">';
    for (i = 0; i < q.lines.length; i++) {
      h += '<li><span class="cq-lines__k">' + esc(q.lines[i].key)
        + (q.lines[i].note ? '<small>' + esc(q.lines[i].note) + '</small>' : '')
        + '</span><span class="cq-lines__v">' + money(q.lines[i].pence) + '</span></li>';
    }
    h += '</ul>';
    h += '<div class="cq-grand"><span>Estimated order total</span><b>' + money(q.totalPence) + '</b></div>';
    if (q.hasStairs) h += '<div class="cq-disc">' + esc(E.DISCLAIMER) + '</div>';

    h += '<div class="cq-bal">'
      + '<div class="cq-bal__row"><span>Estimated order total</span><b>' + money(q.totalPence) + '</b></div>'
      + '<div class="cq-bal__row"><span>Deposit paid online today</span><b>' + money(q.depositPence) + '</b></div>'
      + '<div class="cq-bal__row cq-bal__row--due"><span>Balance due</span><b>' + money(q.balancePence) + '</b></div>'
      + '<p class="cq-bal__how">Pay £50 today to secure your flooring and reserve the required stock. The remaining balance can be paid in cash or by card.</p>'
      + '</div>';

    h += '<div id="cq-stockbox"></div>';
    h += '<label class="cq-f cq-f--wide"><span>Full name</span><input type="text" id="cq-name" value="' + esc(S.name) + '" autocomplete="name"></label>'
      + '<div class="cq-dims">'
      + '<label class="cq-f"><span>Email</span><input type="email" id="cq-email" value="' + esc(S.email) + '" autocomplete="email"></label>'
      + '<label class="cq-f"><span>Telephone</span><input type="tel" id="cq-tel" value="' + esc(S.tel) + '" autocomplete="tel"></label>'
      + '</div>'
      + '<label class="cq-f cq-f--wide"><span>Address</span><input type="text" id="cq-addr" value="' + esc(S.addr) + '" autocomplete="street-address"></label>'
      + '<label class="cq-f"><span>Postcode</span><input type="text" id="cq-postcode" value="' + esc(S.postcode) + '" autocomplete="postal-code"></label>'
      + '<label class="cq-f cq-f--wide"><span>Anything we should know? (optional)</span><textarea id="cq-notes" rows="3">' + esc(S.notes) + '</textarea></label>'
      + '<button type="button" class="cq-pay" id="cq-pay" disabled>' + PAY_LABEL + '</button>'
      + '<p class="cq-err" id="cq-payerr" hidden></p>'
      + '<p class="cq-small">Only the £50 deposit is taken online. Your carpet is reserved on the roll the moment your deposit order is placed, '
      + 'and the balance is paid in cash or by card. Nothing is cut until we have confirmed your measurements with you.</p>';
    return h;
  }

  /* ------------------------------------------------------- live stock check */
  /* The Storefront API is the only figure allowed to decide whether a roll is
     long enough. The theme's own inventory number on this store can be minutes
     out of date, so it is never used for the decision, only for the first
     drawing of the page. Any error, timeout, missing node or non-numeric
     quantity counts as UNKNOWN, and UNKNOWN blocks the deposit. */
  function cqLiveUnits(variantIds) {
    if (!TOKEN) return Promise.resolve({ ok: false, reason: 'notoken' });
    var ids = [], i;
    for (i = 0; i < variantIds.length; i++) {
      ids.push('gid://shopify/ProductVariant/' + String(variantIds[i]).replace(/[^0-9]/g, ''));
    }
    if (!ids.length) return Promise.resolve({ ok: false, reason: 'noids' });
    var query = '{ nodes(ids: ' + JSON.stringify(ids) + ') { ... on ProductVariant { id quantityAvailable availableForSale } } }';
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);
    return fetch(LIVE_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: query }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { if (!r.ok) throw new Error('http-' + r.status); return r.json(); })
      .then(function (j) {
        clearTimeout(timer);
        var nodes = j && j.data && j.data.nodes;
        if (!nodes || nodes.length !== ids.length) throw new Error('shape');
        var byId = {};
        for (var k = 0; k < ids.length; k++) {
          var n = nodes[k];
          if (!n || String(n.id) !== ids[k]) throw new Error('missing');
          var qa = n.quantityAvailable;
          if (typeof qa !== 'number' || !isFinite(qa)) throw new Error('nonnumeric');
          byId[String(variantIds[k])] = { units: qa, forSale: n.availableForSale === true };
        }
        return { ok: true, units: byId, at: Date.now() };
      })
      .catch(function (e) {
        clearTimeout(timer);
        return { ok: false, reason: (e && e.name === 'AbortError') ? 'timeout' : 'error' };
      });
  }

  var LIVE = { status: 'idle', message: '', units: null, at: 0, altRoll: null };

  function liveOk() { return LIVE.status === 'ok'; }

  /* Every roll of the chosen carpet is checked in one call, so we can also say
     whether a different roll of the same colour would cover the job. A job is
     never split across two rolls: two rolls can shade differently. */
  function checkLive(then) {
    var p = product(), q = calc();
    if (!p) { then({ status: 'idle', message: '' }); return; }
    if (p.orderIn) {
      then(TOKEN
        ? { status: 'ok', message: 'Order-in carpet. Nothing is reserved from a roll, so there is no length to check.' }
        : { status: 'notoken', message: MSG_NO_TOKEN });
      return;
    }
    if (!TOKEN) { then({ status: 'notoken', message: MSG_NO_TOKEN }); return; }
    if (!q || !q.ok) { then({ status: 'idle', message: '' }); return; }
    var ids = [];
    for (var i = 0; i < p.rolls.length; i++) ids.push(p.rolls[i].id);
    cqLiveUnits(ids).then(function (res) {
      if (!res.ok) { then({ status: 'unknown', message: MSG_UNKNOWN, reason: res.reason }); return; }
      var chosen = roll(), best = null, bestUnits = -1;
      for (var k = 0; k < p.rolls.length; k++) {
        var rr = p.rolls[k], u = res.units[rr.id];
        if (!u) continue;
        rr.units = u.units;
        rr.lengthM = Math.round(u.units) / 10;
        rr.lengthStatus = E.rollStatus(u.units);
        if (u.units > bestUnits) { bestUnits = u.units; best = rr; }
      }
      var need = q.units;
      var chosenUnits = (chosen && res.units[chosen.id]) ? res.units[chosen.id].units : -1;
      if (chosen && chosenUnits >= need) {
        then({ status: 'ok', units: res.units, at: res.at,
          message: 'Roll ' + chosen.rollNumber + ' has ' + fm(chosenUnits / 10)
            + 'm left, enough for your ' + fm(q.totalCutM) + 'm cut. Checked just now.' });
        return;
      }
      /* Cut to length: the customer typed the length themselves, so the
         answer is the roll's live length and what to do about it. The length
         is never capped for them. Only rolls of the width they picked are
         offered instead. */
      if (isCut()) {
        var altW = null, altU = -1;
        for (k = 0; k < p.rolls.length; k++) {
          var rw = p.rolls[k], uw = res.units[rw.id];
          if (!uw || rw.widthM !== cutWidth() || !E.rollSellable(rw)) continue;
          if (uw.units >= need && (altU < 0 || uw.units < altU)) { altU = uw.units; altW = rw; }
        }
        then({ status: 'overlength', units: res.units, at: res.at, altRoll: altW,
          message: overLengthMessage(Math.max(chosenUnits, 0))
            + (altW ? ' Roll ' + altW.rollNumber + ' has ' + fm(altU / 10) + 'm left and does cover it.' : ' No single roll of this width has ' + fm(q.totalCutM) + 'm left.') });
        return;
      }
      if (best && bestUnits >= need) {
        then({ status: 'otherroll', units: res.units, altRoll: best,
          message: 'Roll ' + (chosen ? chosen.rollNumber : '') + ' has ' + fm(Math.max(chosenUnits, 0) / 10)
            + 'm left, which is not enough for your ' + fm(q.totalCutM) + 'm cut. Roll ' + best.rollNumber
            + ' has ' + fm(bestUnits / 10) + 'm left and does cover it. Please pick that roll.' });
        return;
      }
      then({ status: 'short', units: res.units, message: MSG_NO_SINGLE_ROLL });
    });
  }

  var liveSeq = 0;
  function runLive() {
    var mySeq = ++liveSeq;
    LIVE = { status: 'checking', message: 'Checking this roll now...', units: null, at: 0, altRoll: null };
    paintLive();
    checkLive(function (res) {
      if (mySeq !== liveSeq) return;      /* a newer check has already started */
      LIVE = {
        status: res.status, message: res.message || '', units: res.units || null,
        at: res.at || Date.now(), altRoll: res.altRoll || null, reason: res.reason || ''
      };
      /* The live lengths may change which roll we should recommend. If the
         customer picked the roll themselves we leave their choice alone. */
      if (S.rollAuto && !autoSwitched) {
        var better = recommendRoll();
        if (better && better.id !== String(S.roll)) {
          autoSwitched = true;
          S.roll = better.id;
          lastLiveKey = '';
          render();
          return;
        }
      }
      paintLive();
    });
  }
  var autoSwitched = false;

  function liveHtml() {
    if (LIVE.status === 'idle' || !LIVE.message) return '';
    if (LIVE.status === 'ok') return '<div class="cq-ok">' + esc(LIVE.message) + '</div>';
    if (LIVE.status === 'checking') return '<div class="cq-ok">' + esc(LIVE.message) + '</div>';
    var head = LIVE.status === 'short' ? 'We cannot reserve this cut'
      : (LIVE.status === 'notoken' ? 'We cannot take a deposit yet'
      : (LIVE.status === 'otherroll' ? 'Please pick another roll'
      : (LIVE.status === 'overlength' ? 'That is more than this roll has' : 'We could not check this roll')));
    var h = '<div class="cq-stop"><b>' + esc(head) + '</b><p>' + esc(LIVE.message) + '</p>';
    if (LIVE.status === 'short') {
      h += '<p>Your quote reference is <b>' + esc(mkref()) + '</b>.</p>'
        + '<button type="button" class="cq-next" id="cq-savequote" style="width:auto">Save my quote</button>'
        + '<p class="cq-small" id="cq-savedmsg" hidden>Saved on this device. Quote your reference when you call and we will pick it straight up.</p>';
    }
    return h + '</div>';
  }

  function paintLive() {
    var a = $('cq-livebox'); if (a) a.innerHTML = liveHtml();
    var b = $('cq-stockbox'); if (b) b.innerHTML = liveHtml();
    var pay = $('cq-pay');
    if (pay) {
      pay.disabled = !liveOk();
      pay.textContent = liveOk() ? PAY_LABEL : (LIVE.status === 'checking' ? 'Checking the roll...' : PAY_LABEL);
    }
    var over = $('cq-cutover');
    if (over) over.hidden = liveKeyNow() === lastLiveKey && (LIVE.status === 'overlength' || LIVE.status === 'short' || LIVE.status === 'otherroll');
    var next = $('cq-next');
    var sk = stepKey();
    if (next && (sk === 'carpet' || (sk === 'measure' && isCut()))) next.disabled = !canContinue();
  }

  var PAY_LABEL = 'Pay £50 deposit and reserve my carpet';

  /* -------------------------------------------------------------- deposit */
  function depositVariant() {
    var list = CFG.depVars || [];
    var want = S.fitting === 'yes' ? /fitting|survey/i : (S.route === 'delivery' ? /delivery/i : /collect/i);
    for (var i = 0; i < list.length; i++) if (want.test(list[i].t || '')) return list[i].id;
    return CFG.depVar || 0;
  }

  function quoteProps(q, p, r) {
    var props = {};
    props['Quote reference'] = mkref();
    props['Customer name'] = S.name || '';
    props['Email'] = S.email || '';
    props['Telephone'] = S.tel || '';
    props['Address'] = (S.addr || '').slice(0, 250);
    props['Postcode'] = S.postcode || '';
    props['Carpet'] = p.title;
    if (!p.orderIn) props['Roll number'] = r.rollNumber;
    if (!p.orderIn) props['Where it is'] = E.siteGroup(r.site) || 'Showroom';
    props['Roll width'] = fm(q.rollWidthM) + ' m';
    for (var i = 0; i < q.areas.length; i++) {
      var a = q.areas[i];
      if (a.kind === 'room') {
        props[(a.name || ('Room ' + (i + 1))).slice(0, 240)] =
          (fm(a.roomLM) + 'm x ' + fm(a.roomWM) + 'm = ' + fm(a.floorM2) + ' m2, cut ' + fm(a.cutM) + 'm'
            + (a.join ? ', join needed' : '') + ', ' + a.doorways + ' doorways').slice(0, 250);
      } else if (a.kind === 'cut') {
        props[(a.name || 'Cut to length').slice(0, 240)] =
          (fm(a.cutM) + 'm x ' + E.fmtW(a.rollWidthM) + 'm = ' + fm(a.chargeableM2) + ' m2, cut straight off the roll, no join, no trimming allowance').slice(0, 250);
      } else {
        for (var f = 0; f < a.strips.length; f++) {
          props[(a.strips[f].label + ' stairs').slice(0, 240)] =
            (a.strips[f].stairs + ' stairs, tread ' + fm(a.strips[f].treadM) + 'm, riser ' + fm(a.strips[f].riserM)
              + 'm, strip ' + fm(a.strips[f].lengthM) + 'm x ' + fm(a.strips[f].cutWidthM) + 'm').slice(0, 250);
        }
        if (a.winders.length) props['Winder treads'] = a.winders.length + ' pieces, each ' + fm(a.winders[0].downM) + 'm x ' + fm(a.winders[0].acrossM) + 'm (estimate)';
        for (f = 0; f < a.landings.length; f++) {
          props[(a.landings[f].name || ('Landing ' + (f + 1))).slice(0, 240)] =
            (fm(a.landings[f].lengthM) + 'm x ' + fm(a.landings[f].widthM) + 'm = ' + fm(a.landings[f].floorM2) + ' m2').slice(0, 250);
        }
        props['Stair width'] = a.coverage === 'runner'
          ? 'Finished runner width ' + fm(a.finishedWidthM) + 'm, cut from the roll at ' + fm(a.cutWidthM) + 'm'
          : 'Full width ' + fm(a.stairWidthM) + 'm, cut from the roll at ' + fm(a.cutWidthM) + 'm';
      }
    }
    props['Floor area we will fit'] = fm(q.floorM2) + ' m2';
    if (q.hasCut) props['Length requested'] = lengthRequested(q).slice(0, 250);
    props['Recommended linear cut'] = fm(q.totalCutM) + ' m';
    props['Chargeable carpet area'] = fm(q.chargeableM2) + ' m2';
    props['Carpet price'] = money(q.carpetPence);
    props['Underlay'] = q.accessories.underlay.pence
      ? q.accessories.underlay.choice + ', ' + q.accessories.underlay.m2 + ' m2 = ' + money(q.accessories.underlay.pence)
      : (S.underlay === 'have' ? 'Customer already has underlay' : 'None');
    props['Gripper'] = q.accessories.gripper.pence
      ? q.accessories.gripper.lengths + ' lengths = ' + money(q.accessories.gripper.pence)
      : (S.gripper === 'reuse' ? 'Reuse existing where suitable' : 'None');
    props['Door bars'] = q.accessories.doorBars.count
      ? q.accessories.doorBars.count + ' at ' + money(RATES.doorbar) + ' = ' + money(q.accessories.doorBars.pence)
        + (S.doorBarOther ? ', meeting ' + String(S.doorBarOther).slice(0, 120) : '') + '. Colour and profile confirmed before the order proceeds.'
      : 'None';
    props['Uplift of old floor'] = q.accessories.uplift.pence ? money(q.accessories.uplift.pence) : 'Not required';
    props['Disposal'] = q.accessories.disposal.pence ? money(q.accessories.disposal.pence) : 'Not required';
    props['Furniture moving'] = q.accessories.furniture.pence ? q.accessories.furniture.rooms + ' rooms = ' + money(q.accessories.furniture.pence) : 'None';
    props['Fitting'] = q.fitting.wanted
      ? money(q.fitting.pence) + (q.fitting.minApplied ? ' (minimum charge)' : ' (' + fm(q.fitting.m2) + ' m2 at ' + money(RATES.fitting) + ' per m2)')
      : 'Not requested, supply only';
    props['Delivery or collection'] = q.delivery.label + (q.delivery.pence ? ' ' + money(q.delivery.pence) : ' (no charge)');
    props['Estimated order total'] = money(q.totalPence);
    props['Deposit paid online'] = money(q.depositPence);
    props['Balance due'] = money(q.balancePence);
    props['Balance payable'] = 'In cash or by card';
    props['Cutting status'] = 'RESERVED, NOT APPROVED FOR CUTTING. Confirm measurements before cutting.';
    if (q.hasStairs) props['Stair note'] = E.DISCLAIMER;
    if (q.estimate) props['Winding stair note'] = 'Estimate only. Customer to email photographs to help@innovationflooringdirect.com quoting ' + mkref() + '.';
    props['Cutting plan'] = cuttingPlanText(q, r).slice(0, 250);
    if (p.orderIn) {
      props['Carpet supply'] = E.ORDER_IN_NOTE;
      props['Ordered roll width'] = fm(q.rollWidthM) + ' m';
    }
    if (S.notes) props['Customer notes'] = String(S.notes).slice(0, 250);
    /* Machine-readable backstop for the carpet Flow. The flooring reserve
       properties are deliberately NOT written here. */
    if (p.orderIn) {
      props['_carpet_order_in'] = 'yes';
      props['_carpet_cut_m'] = fm(q.totalCutM);
      props['_carpet_width_m'] = fm(q.rollWidthM);
    } else {
      props['_carpet_roll_variant'] = String(r.id);
      props['_carpet_units'] = String(q.units);
      props['_carpet_cut_m'] = fm(q.totalCutM);
      props['_carpet_width_m'] = fm(q.rollWidthM);
    }
    props['_carpet_quote_ref'] = mkref();
    return props;
  }

  /* One line per cut, so the shop can work straight from the order. */
  function cuttingPlanText(q, r) {
    var plan = E.cuttingPlan(q.areas, q.rollWidthM), out = [];
    for (var i = 0; i < plan.rows.length; i++) {
      var row = plan.rows[i], a = q.areas[i];
      var bit = row.name + ': ' + fm(row.cutM) + 'm from ' + (r.orderIn ? fm(r.widthM) + 'm-wide carpet' : 'roll ' + r.rollNumber)
        + ', ' + fm(a.chargeableM2) + 'm2';
      if (row.offcutWidthM > 0) bit += ', offcut ' + fm(row.offcutWidthM) + 'm x ' + fm(row.offcutLengthM) + 'm';
      out.push(bit);
    }
    return out.join(' | ');
  }

  function addLine(item) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin', body: JSON.stringify(item)
    }).then(function (res) {
      if (res.ok) return res.json();
      return res.json().catch(function () { return {}; }).then(function (j) {
        var e = new Error('add-failed'); e.status = res.status; e.payload = j; throw e;
      });
    });
  }

  function pay(btn) {
    var err = $('cq-payerr');
    var label = PAY_LABEL;
    function fail(t) { if (err) { err.textContent = t; err.hidden = false; } btn.disabled = false; btn.textContent = label; }
    if (err) err.hidden = true;
    var p = product(), q = calc();
    var r = p && p.orderIn ? orderInRoll() : roll();
    if (!p || !r || !q || !q.ok) { fail('Please finish your quote before paying the deposit.'); return; }
    if (!(S.name || '').trim()) { fail('Please add your name so we know who the quote belongs to.'); return; }
    if (!(S.email || '').trim() && !(S.tel || '').trim()) { fail('Please add an email address or a telephone number so we can confirm your order.'); return; }
    var dep = depositVariant();
    if (!dep) { fail('The deposit product is not set up yet. Please call the shop and we will take it from here.'); return; }
    if (!TOKEN) { fail(MSG_NO_TOKEN); return; }

    btn.disabled = true; btn.textContent = 'Checking the roll...';
    /* The live length is read again here, on the click, immediately before the
       cart is touched. Nothing is added unless this check comes back OK. */
    checkLive(function (res) {
      LIVE = { status: res.status, message: res.message || '', units: res.units || null, at: Date.now(), altRoll: res.altRoll || null };
      paintLive();
      if (res.status !== 'ok') {
        fail('We could not reserve this cut. Please read the message above.');
        return;
      }
      btn.disabled = true; btn.textContent = 'Reserving your carpet...';
      var attrs = {
        'Quote reference': mkref(),
        'Quote customer': S.name || '',
        'Quote estimated total': money(q.totalPence)
      };
      /* Order-in carpet: there is no roll on a rack, so nothing physical is
         reserved. Only the deposit line goes in the cart. */
      var rollProps = null;
      if (!p.orderIn) {
        rollProps = {};
        rollProps['Reserved carpet cut'] = fm(q.totalCutM) + ' linear metres from a ' + fm(q.rollWidthM) + 'm-wide roll, ' + fm(q.chargeableM2) + 'm2';
        rollProps['Carpet value'] = money(q.carpetPence) + ', included in your quotation and balance (not charged on this line)';
        rollProps['Roll number'] = r.rollNumber;
        rollProps['Cutting status'] = 'Reserved. Measurements confirmed before cutting.';
        rollProps['_carpet_units'] = String(q.units);
        rollProps['_carpet_cut_m'] = fm(q.totalCutM);
        rollProps['_carpet_width_m'] = fm(q.rollWidthM);
        rollProps['_carpet_roll_variant'] = String(r.id);
        rollProps['_carpet_quote_ref'] = mkref();
      }
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin', body: JSON.stringify({ attributes: attrs })
      })
        /* The roll line goes first, so if Shopify itself refuses the length
           nothing else has been added and no deposit is taken. */
        .then(function () {
          if (!rollProps) return null;
          return addLine({ id: Number(r.id), quantity: q.units, properties: rollProps });
        })
        .then(function () { return addLine({ id: Number(dep), quantity: 1, properties: quoteProps(q, p, r) }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (e) {
          if (e && e.status === 422) {
            LIVE = { status: 'short', message: 'Roll ' + r.rollNumber + ' no longer has enough carpet left for your '
              + fm(q.totalCutM) + 'm cut. Nothing has been charged and nothing has been reserved. '
              + MSG_NO_SINGLE_ROLL, units: null, at: Date.now(), altRoll: null };
            paintLive();
            fail('We could not reserve this cut. Please read the message above.');
          } else {
            fail('Sorry, we could not start the checkout. Nothing has been lost. Please try again, or call the shop.');
          }
        });
    });
  }

  /* --------------------------------------------------------------- events */
  function setPath(path, value) {
    var parts = path.split('.'), o = S;
    for (var i = 0; i < parts.length - 1; i++) {
      var k = parts[i];
      if (/^\d+$/.test(k)) k = parseInt(k, 10);
      if (o[k] == null) o[k] = /^\d+$/.test(parts[i + 1]) ? [] : {};
      o = o[k];
    }
    var last = parts[parts.length - 1];
    if (/^\d+$/.test(last)) last = parseInt(last, 10);
    o[last] = value;
  }
  function getPath(path) {
    var parts = path.split('.'), o = S;
    for (var i = 0; i < parts.length; i++) {
      if (o == null) return undefined;
      var k = /^\d+$/.test(parts[i]) ? parseInt(parts[i], 10) : parts[i];
      o = o[k];
    }
    return o;
  }
  /* Dimension inputs are stored in metres whatever the customer typed in. */
  function isDim(path) {
    return /\.(l|w|depth|width|tread|riser|length|maxTread|stairWidth|runnerWidth)$/.test(path) || /^stairs\.(stairWidth|runnerWidth)$/.test(path) || path === 'cutLen';
  }

  root.addEventListener('click', function (ev) {
    var t = ev.target.closest ? ev.target : ev.target.parentNode;
    var el;
    if ((el = t.closest('[data-job]'))) { S.job = el.getAttribute('data-job'); prepJob(); render(); return; }
    if ((el = t.closest('[data-unit]'))) { S.unit = el.getAttribute('data-unit'); render(); return; }
    if ((el = t.closest('[data-set]'))) { setPath(el.getAttribute('data-set'), el.getAttribute('data-val')); render(); return; }
    if ((el = t.closest('[data-bool]'))) { S[el.getAttribute('data-bool')] = el.getAttribute('data-val') === '1'; render(); return; }
    if ((el = t.closest('[data-runner]'))) {
      var v = parseFloat(el.getAttribute('data-runner'));
      S.stairs.runnerWidth = v || 0.75; render(); return;
    }
    if ((el = t.closest('[data-inc]'))) {
      var path = el.getAttribute('data-inc'), by = parseInt(el.getAttribute('data-by'), 10);
      var cur = num(getPath(path));
      setPath(path, Math.max(0, cur + by)); render(); return;
    }
    if ((el = t.closest('[data-prod]'))) {
      var hnd = el.getAttribute('data-prod');
      S.prod = hnd;
      var pp = product();
      /* Put the customer on the roll we would recommend, so the common case is
         one tap. Every other roll is still one tap away. */
      var recPick = pp && !pp.orderIn ? recommendRoll(pp) : null;
      S.roll = recPick ? recPick.id : '';
      S.rollAuto = !!recPick;
      S.orderWidth = 0; S.cutWidth = 0;
      lastLiveKey = ''; autoSwitched = false;
      render(); return;
    }
    if ((el = t.closest('[data-roll]'))) { S.roll = el.getAttribute('data-roll'); S.rollAuto = false; lastLiveKey = ''; autoSwitched = false; render(); return; }
    if ((el = t.closest('[data-orderwidth]'))) { S.orderWidth = parseFloat(el.getAttribute('data-orderwidth')); lastLiveKey = ''; render(); return; }
    if ((el = t.closest('[data-cutwidth]'))) {
      /* A new width means a new set of rolls: the roll is picked again from
         those, and the live check starts over. */
      S.cutWidth = parseFloat(el.getAttribute('data-cutwidth')) || 0;
      S.orderWidth = S.cutWidth;
      S.roll = ''; S.rollAuto = true; lastLiveKey = ''; autoSwitched = false;
      render(); return;
    }
    if (t.closest('#cq-savequote')) {
      try { localStorage.setItem('ifdCQ-saved-' + mkref(), JSON.stringify({ ref: mkref(), saved: new Date().toISOString(), state: S })); } catch (e2) {}
      var sm = $('cq-savedmsg'); if (sm) sm.hidden = false;
      return;
    }
    if ((el = t.closest('[data-addroom]'))) { S.rooms.push(newRoom('')); render(); return; }
    if ((el = t.closest('[data-delroom]'))) { S.rooms.splice(parseInt(el.getAttribute('data-delroom'), 10), 1); render(); return; }
    if ((el = t.closest('[data-addextra]'))) {
      var ri = parseInt(el.getAttribute('data-addextra'), 10);
      S.rooms[ri].extras = S.rooms[ri].extras || [];
      S.rooms[ri].extras.push({ depth: '', width: '', side: 'width' }); render(); return;
    }
    if ((el = t.closest('[data-delextra]'))) {
      var pr = el.getAttribute('data-delextra').split('.');
      S.rooms[+pr[0]].extras.splice(+pr[1], 1); render(); return;
    }
    if ((el = t.closest('[data-addland]'))) {
      S.stairs.landings = S.stairs.landings || [];
      S.stairs.landings.push({ name: '', length: '', width: '', doorways: 1 }); render(); return;
    }
    if ((el = t.closest('[data-delland]'))) { S.stairs.landings.splice(parseInt(el.getAttribute('data-delland'), 10), 1); render(); return; }
    if (t.closest('#cq-pay')) { pay(t.closest('#cq-pay')); return; }
  });

  function prepJob() {
    var j = job(); if (!j) return;
    if (j.rooms && !S.rooms.length) S.rooms.push(newRoom(j.roomName || ''));
    if (!j.rooms) S.rooms = [];
    if (j.stairs) { if (!S.stairs) S.stairs = newStairs(j.stairs); else if (j.k !== 'turning' && S.stairs.type !== 'straight' && j.k !== 'house') S.stairs.type = 'straight'; }
    else S.stairs = null;
  }

  root.addEventListener('input', function (ev) {
    var el = ev.target;
    var path = el.getAttribute && el.getAttribute('data-path');
    if (path) {
      var v = el.value;
      if (isDim(path) && el.type === 'number') v = E.toMetres(v, S.unit);
      setPath(path, v);
      save();
      if (stepKey() === 'measure') { if (isCut()) redrawCut(); else redrawDiagram(el); }
      return;
    }
    var map = { 'cq-name': 'name', 'cq-email': 'email', 'cq-tel': 'tel', 'cq-addr': 'addr', 'cq-postcode': 'postcode', 'cq-notes': 'notes' };
    if (map[el.id]) { S[map[el.id]] = el.value; save(); }
  });

  /* Keeps the room drawing live without losing the caret in the field. */
  var redrawTimer = null;
  function redrawDiagram(el) {
    clearTimeout(redrawTimer);
    redrawTimer = setTimeout(function () {
      var box = el.closest ? el.closest('.cq-room') : null;
      if (!box) return;
      var fig = box.querySelector('.cq-diag');
      var m = /rooms\.(\d+)\./.exec(el.getAttribute('data-path') || '');
      if (!m) return;
      var svg = roomSvg(S.rooms[+m[1]]);
      if (fig && svg) fig.innerHTML = svg + '<figcaption>Your room as you have measured it. The carpet is cut into the longest and widest points so it always covers.</figcaption>';
      $('cq-next').disabled = !canContinue();
      basket();
    }, 220);
  }

  /* Keeps the cut card, the roll choice, the Continue button and the basket
     in step with the length as it is typed, without losing the caret. The
     live check runs once the typing pauses; a stale answer is never shown
     against a newer length (see cutCard). */
  var cutTimer = null;
  function redrawCut() {
    clearTimeout(cutTimer);
    cutTimer = setTimeout(function () {
      var p = product();
      if (p && !p.orderIn) ensureCutRoll();
      var rl = $('cq-cutrolls');
      if (rl) rl.innerHTML = cutRollList(p);
      var box = $('cq-cutres');
      if (box) box.innerHTML = cutResult();
      $('cq-next').disabled = !canContinue();
      basket();
      save();
      maybeRunLive();
    }, 350);
  }

  root.addEventListener('change', function (ev) {
    if (stepKey() === 'measure' && ev.target.getAttribute && ev.target.getAttribute('data-path')) {
      if (isCut()) { clearTimeout(cutTimer); }
      render();
    }
  });

  $('cq-next').addEventListener('click', function () {
    if (!canContinue()) return;
    S.idx = Math.min(steps().length - 1, stepIndex() + 1);
    render(); top();
    if (stepKey() === 'quote') {
      runLive();
    }
  });
  $('cq-back').addEventListener('click', function () { S.idx = Math.max(0, stepIndex() - 1); render(); top(); });
  $('cq-restart').addEventListener('click', function () {
    if (!window.confirm('Start again? This clears the measurements and choices in this quote. Anything already in your basket is not affected.')) return;
    S = blank(); save(); render(); top();
  });
  function top() {
    var r = root.getBoundingClientRect();
    window.scrollTo({ top: r.top + window.pageYOffset - 90, behavior: 'smooth' });
  }

  /* Deep link from a roll product page or the remnants page. */
  (function deeplink() {
    var q = new URLSearchParams(window.location.search);
    var c = q.get('carpet'), rl = q.get('roll'), jb = q.get('job'), ln = q.get('len');
    /* Round 5: ?job=cut (with or without a carpet) opens the cut-to-length
       route; ?len= prefills the length in metres, exactly as typed, so the
       rounding is shown to the customer rather than done behind their back. */
    var wantCut = jb === 'cut';
    if (wantCut && S.job !== 'cut') {
      S.job = 'cut'; S.cutLen = ''; S.cutWidth = 0; S.roll = ''; S.rollAuto = false; S.idx = 1;
      prepJob();
    }
    if (wantCut && ln != null && num(ln) > 0) S.cutLen = num(ln);
    if (!c) { if (wantCut) S.idx = 1; return; }
    for (var i = 0; i < PRODUCTS.length; i++) {
      if (PRODUCTS[i].handle === c) {
        if (S.prod !== c) { S.roll = ''; S.rollAuto = false; S.cutWidth = 0; S.orderWidth = 0; }
        S.prod = c;
        if (rl) { for (var j = 0; j < PRODUCTS[i].rolls.length; j++) if (PRODUCTS[i].rolls[j].id === String(rl)) { S.roll = String(rl); S.rollAuto = false; } }
        else if (!PRODUCTS[i].orderIn && PRODUCTS[i].rolls.length === 1) S.roll = PRODUCTS[i].rolls[0].id;
        if (wantCut) { S.idx = 2; }                       /* straight to the length screen */
        else if (!S.job) { S.job = 'one'; prepJob(); }
        break;
      }
    }
  }());

  prepJob();
  render();
  window.CQ = { S: S, calc: calc, engine: E, products: PRODUCTS, render: render, go: function (i) { S.idx = i; render(); } };
}());
